import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { getAxiosResponse, putAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { Link, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import $, {data, event } from "jquery";
import { getHourDifference,getDayDifference, utcDateTimeWithTimeZone, PROJECT_DATE_FORMAT, TIME_LIST, transformBlankToNull,getLoggedInUserRole, TIME_LIST_DATA, timeStamp, getTimeStamp, dateFormatAccToTimeZone, roundToFullHour, isSameDay, getDateTimestamp} from "../../services/Util";
import DatePickerCalendar from "../../components/dashboard/calendars/DatePickerCalendar";
import { RotatingLines } from "react-loader-spinner";
import { useNavigate, useLocation } from "react-router-dom";
import { updateInitializedProjectWorkflows } from "../../redux/reducers/InitializedProjectWorkflowsSlice";
import { updateProjectInfo } from "../../redux/reducers/ProjectInfoSlice";
import DataTable from "react-data-table-component";
import { updateFollowersCollection } from '../../redux/reducers/ProjectFollowersSlice';
import Constants from "../../Constants";
import { confirmAlert } from 'react-confirm-alert';
import SelectWorkflow from "../../components/createProject/SelectWorkflow";
import { updateSelectedProjectWorkflow } from "../../redux/reducers/SelectedProjectWorkflowSlice";
import { updateProjectEditMessage } from "../../redux/reducers/ProjectEditMessageSlice";
import ErrorMessage from "../../components/ErrorMessage";
import ReactTooltip from "react-tooltip";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import { handleError } from "../../services/authApiRoutes/APImethods";
import { PurchaseOrder } from "./PurchaseOrder";
import moment from "moment";
import { ConditionalBlock } from "../../ConditionalBlock";
import { CrossIcon, FollowerTooltipIcon, calenderIcon } from "../../AppIcons";
import dateUtil from "../../services/DateUtil";

export default function ProjectDetailEdit() {
	const param = useParams();
	const scrollRef = useRef(null);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const translate = t;

	const [projectDataCount, setProjectCount] = useState({})
	const [workspaceCampaign, setWorkspaceCampaign] = useState([]);
	const [intendendUseTaskData, setIntendedUseTask] = useState([])
	const [tagsData, setTagsData] = useState([])
	const [tagsDropdown, setTagsDropdown] = useState([]);
	const [departments, updateDepartment] = useState([]);
	const [sourceLanguage, setSourceLanguage] = useState([]);
	const [customerPurchaseOrder, setCustomerPurchaseOrder] = useState([])
	const [customerPurchaseOrderData, setCustomerPurchaseOrderData] = useState([])
	const refToggle = useRef(null);
	const refToggle2 = useRef(null);
	const refCalendar = useRef(null);
	const refCalendar2 = useRef(null);
	const [refs, setRefs] = useState({});
	const initialTranslationTooltipRef = useRef(null);
	const vendorBidTooltipRef = useRef(null);
	const bidTooltipRef = useRef(null);
	const purchaseOrderTooltipRef = useRef(null);
	const targetLanguageTooltipRef = useRef(null);
	const projectFollowers1Ref = useRef(null);
	const [bidDueTime, setBidDueTime] = useState(-1)
	const [invalidIntendedUse, setInvalidIntendedUse] = useState(false)
	const [deliveryDueTime, setDeliveryDueTime] = useState(-1)
	const [projectFollowers, setProjectFollowers] = useState([])
	const [projectOwner, setProjectOwner] = useState([])
	const [globalOverlay, showGlobalOverlay] = useState(true);
	const [tabStatus, setTabStatus] = useState(true)
	const [toggle, toggleCal] = useState(false);
	const [toggleIntialCal, toggleIntialCalFlag] = useState(false);
	const [projectWorkflows, setprojectWorkflows] = useState([])
	const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
	const [minDueDate, setMinDueDate] = useState("")
	const [pastCampaignStatus, setPastCampaignStatus] = useState(false);
	const [showModalSelectWorkflow, setShowModalSelectWorkflow] = useState(false);
	const [followersToBeAdded, setFollowersToBeAdded] = useState([]);
	const [intendedUseData, setIntendedUseData] = useState(null)
	const [targetDate, setTargetDate] = useState(null)
	const [languageStatus, setLanguageStatus] = useState(false)
	const [tagsCheck, setTagsCheck] = useState([]);
	const [targetLanguage, setTargetLanguage] = useState([]);
	const [allTargetLanguageCollection, setAllTargetLanguageCollection] = useState([]);
	const [selectedTargetLanguageList, setSelectedTargetLanguageList] = useState([]);
	const [selectedSourceLanguage, setSelectedSourceLanguage] = useState("");
	const [allSourceLanguageCollection, setAllSourceLanguageCollection] = useState([]);
	const [members, setMembers] = useState([]);
	const [followersCount, setProjectFollowersCount] = useState([])
	const [sourcelanguageCount, setSourceLanguageCount] = useState([])
	const [targetLanguageCount, setTargetLanguageCount] = useState([])
	const [toggleCleared, setToggleCleared] = useState(false);
	const [depId, setDepId] = useState(null);
	const [projectStatus, setProjectStatus] = useState(null)
	const roleArray = getLoggedInUserRole();
	const [initiateCancelOrSaveExitProject, setInitiateCancelOrSaveExitProject] = useState(false);
	const [successMessage, setSuccessMessage] = useState(Constants.BLANK);
	const [ownerData, setOwnerData] = useState(null)
	const [targetLangCode, setTargetLanguageCode] = useState("")
	const [errorMessage, setErrorMessage] = useState("")
	const [projectBidDueDate, setProjectBidDueDate] = useState(null);
	const [dateValidation, setDateValidation] = useState(false)
	const [projectStatusEditableField, setProjectStatusEditableField] = useState(["name", "campaign", "priority", "description", "notes", "poNumber", "deliveryDueDate", "bidDueDate", "targetLanguages", "intendedUse", "reviewDueDate"])
	const [newBidModelStatus, setNewBidModelStatus] = useState(false)
	const [projectDeliveryDueDate, setProjectDeliveryDueDate] = useState("");
	const [bidSelectDeadlineDate, setBidSelectDeadlineDate] = useState("");
	const [projectDepartmentId, setProjectDepartmentId] = useState("");
	const [purchaseOrderRequired,setPurchaseOrderRequired]=useState(false)
	const [languageDetail,setLanguageDetail] = useState({})
	const [projectWorkFlowReduxTemp,setProjectWorkFlowReduxTemp]=useState([])
	const [followersCollectionData,setFollowerCollectionData]=useState([])
	const location = useLocation()
	const [projectInfo,setProjectInfo]=useState("")
	const [projectOwnerData,setProjectOwnerData]=useState("")
	const state = location.state;
	const[ownerLoading,setOwnerLoading]=useState(true) 
	const [bidDueDateHoursList,setBidDueDateHourList]=useState(TIME_LIST_DATA)
	const [deliveryDueDateHoursList,setDeliveryDueDateHourList]=useState(TIME_LIST)
    const [needItSoonerStatus,setNeedItSooner]=useState(false)
	const [disableButton, setDisableButton] = useState(false);
	const [selected, setSelected] = useState("");
	const [bumpDeliveryDueDate, setBumpDeliveryDueDate] = useState(false);
	const [calculateBidSelectionDeadline, setCalculateBidSelectionDeadline] = useState(false);
	const [invokeDateChanged, setInvokeDateChanged] = useState(false);
	const [custDateFormat, setCustDateFormat] = useState(PROJECT_DATE_FORMAT);


	const custBootstrapDataRedux = useSelector((reduxStore) => reduxStore.customer_bootstrap_data).value;
	const projectFollowersRedux = useSelector((projectFollowersSlice) => projectFollowersSlice.project_followers);
	const projectWorkflowsRedux = useSelector((reduxStore) => reduxStore.initialized_project_workflows)?.value?.resource;
	const userTimeZone = custBootstrapDataRedux?.user?.timeZone;
	const locale = custBootstrapDataRedux?.user?.locale.replace("_", "-");
	const accountPermission = useSelector((updateCustomerBootstrapData) => updateCustomerBootstrapData.customer_bootstrap_data).value;
	const projectData = useSelector((reduxStore) => reduxStore.project_info).value;
	const projectWorkflow = useSelector((reduxStore) => reduxStore.initialized_project_workflows);
	const projectWorkflowsData = useSelector((reduxStore) => reduxStore.initialized_project_workflows).value.resource;
	const projectWorkflowDisplayNameData = useSelector((reduxStore) => reduxStore.initialized_project_workflows).value.displayName;
	const selectedProjectWorkflow = useSelector((selectedProjectWorkflowSlice) => selectedProjectWorkflowSlice.selected_project_workflow).value;
	const owner = useSelector((loginSessionDetail) => loginSessionDetail.loginSession).value
	const projectEditMessage = useSelector((projectEditMessageSlice) => projectEditMessageSlice.project_edit_message_slice).value;


	const MINIMUM_RUSH_BID_DUE_DATE_DELAY= 2;
	const MINIMUM_BID_DUE_DATE_DELAY= 24;
	const CURRENT_PAGE_NAME= "projectDetailEdit";
	const MAX_CHARS = 50;

	useEffect(()=>{
		if(state && state?.langData){
			setLanguageDetail(state?.langData)
		}
	},[state])	

	useEffect(()=>{
		setCustDateFormat(custBootstrapDataRedux?.dateFormatInDays?.toUpperCase())
	},[custBootstrapDataRedux])
	
	const addFollower = () => {
		setMembers([...members, ...followersToBeAdded])
		setToggleCleared(true)
		let followers = [...members, ...followersToBeAdded].map(data => {
			if(data?.reviewLanguage &&  data?.reviewLanguage?.length > 0){
			return	{
					applicationVersion: null,
					customerUser: data,
					id: null,
					path: null,
					projectWorkflowAssignee: false,
					reviewLanguages: data?.reviewLanguage !==undefined?data?.reviewLanguage:null,
				}
			}else{
				return	{
					applicationVersion: null,
					customerUser: data,
					id: null,
					path: null,
					projectWorkflowAssignee: false,
					reviewLanguages: data?.reviewLanguage !==undefined?data?.reviewLanguage:null,
					unremovable:false
				}
			}
		})
             
		dispatchFinalDataToRedux('projectFollowers', followers)
		setProjectFollowers(projectFollowers.filter(y => !followersToBeAdded.some(x => x.userId === y.userId)));
		hideModalSelectWorkflow();
		$('.saveFocus').trigger('focus');
	}

	const dispatchFinalDataToRedux = (type, value) => {
		dispatch(updateProjectInfo({
			type: type,
			value: value
		}));
	}

	const dispatchProjectEditMessageRedux = (value) => {
		dispatch(updateProjectEditMessage(value));
	}
	function displayModalSelectWorkflow() {
		setShowModalSelectWorkflow(true);
		setToggleCleared(false)
		document.body.classList.add('modal-open');
		setTimeout(() => {
			$("#close-btn-id").trigger("focus");
			$(".inner-lightbox-panel").on("keydown", function (e) {
			  if (e.key === Constants.ESCAPE) {
				hideModalSelectWorkflow();
			  }
			});
		  });
	}
	
	const handleKeyEditflow = (event) => {
		if (event.key === Constants.ENTER) {
			setTimeout(() => {
				$('.add-another').trigger('focus');
			}, 100);
		}
        if (event.key === Constants.TAB) {
          if (event.shiftKey === false) {
            event.preventDefault();
            $("#close-btn-id").trigger("focus");
          }
        }
      };
	  const handleKeyCloseflow = (event) => {
		if (event.key === Constants.ENTER) {
			setTimeout(() => {
				$('.add-another').trigger('focus');
			}, 100);
		}
        if (event.key === Constants.TAB) {
          if (event.shiftKey === true) {
            event.preventDefault();
            $("#cancel-popup-id").trigger("focus");
          }
        }
      };
	const displayModalonKeydown = (e) => {
		if (e.key === Constants.ENTER) {
			displayModalSelectWorkflow();
		}
	}
	

	const customSort = (column, sortDirection)=>{
		$(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
		.attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
	};

	$(document).ready(function(){
		$(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true");
		$(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
		$(".rdt_Table").attr("aria-label","Add Another"); 
		$('.rdt_Table input').parent().attr("role","cell")
   	})

	function displayNewBidModel() {
		setNewBidModelStatus(true);
		setToggleCleared(false)
		document.body.classList.add('modal-open');
		setTimeout(() => {
			$(".first-focus").trigger("focus");
			$(".first-focus").on("keydown", function (e) {
			  if (e.key === Constants.TAB) {
				if (e.shiftKey === true) {
				  e.preventDefault();
				  $("#renameId").trigger("focus");
				}
			  }
			});
			$(".inner-lightbox-panel").on("keydown", function (e) {
			  if (e.key === Constants.ESCAPE) {
				hideNewBidModal();
			  }
			});
		  }, 200);
	}
	const handleKeyDeleteflow = (event) => {
        if (event.key === Constants.TAB) {
          if (event.shiftKey === false) {
            event.preventDefault();
            $(".first-focus").trigger("focus");
          }
        }
      };

	const clearSourceLanguage = (event) => {
		setSelectedSourceLanguage("");
		setTargetLanguage(allTargetLanguageCollection);
	}

	const clearSourceLanguageOnKeydown = (event) => {
		if (event.key === Constants.ENTER) {
			clearSourceLanguage();
		}
	}

	const clearTargetLanguage = (language) => {
		let projectWorkflowLanguage = projectWorkflow.value.displayName.filter(data => data.code !== language?.code)
		let resourceData = projectWorkflow.value.resource.filter(data => data.language !== language?.language)
		let data = { displayName: projectWorkflowLanguage, resource: resourceData }
		dispatch(updateInitializedProjectWorkflows(data));
		let finalTargetLanguaze = selectedTargetLanguageList.filter((lang) => lang.code !== language.code)
		dispatchFinalDataToRedux('targetLanguages', finalTargetLanguaze?.map(lan => ({...lan,label:lan?.language})))
		setSelectedTargetLanguageList(finalTargetLanguaze);
		setTargetLanguage((targetLang) => [...targetLang, {...language,label:language?.display}]);
		setSourceLanguage((sourceLang) => [...sourceLang, {...language,label:language?.display}]);
		const selectedElement = $(document.activeElement).closest(".multiselect-output");
		if($(document.activeElement).is(':last-child') &&
		  selectedElement.children().length > 1){
			selectedElement.find('button:nth-last-child(2)').trigger('focus');
		} else if($(document.activeElement).is(':last-child')){
		  $(document.activeElement).closest(".wrap-dropdown").find('.global-dropdown-block input:first-of-type').trigger('focus');
		}
	}

	const clearTargetLanguageOnKeydown = (event, language) => {
		if (event.key === Constants.ENTER) {
			clearTargetLanguage(language);
		}
	}

	const handleSourceLanguageChange = (event) => {
		setSelectedSourceLanguage(event)
		dispatchFinalDataToRedux('sourceLanguage', event?.language)
		setTargetLanguage(allTargetLanguageCollection.filter((lang) => event.code !== lang.code));
	};

	const handleTargetLanguageChange = (event) => {
		let targetLang = event;
		setTargetLanguageCode(targetLang?.code)
		let filteredTargetLang = targetLanguage.filter((lang) => targetLang.code !== lang.code);
		setTargetLanguage(filteredTargetLang?.map(data=>({...data,label:data?.display})));
		setSelectedTargetLanguageList((selectedTargetLanguageList) => [...selectedTargetLanguageList, event]);
		setSourceLanguage(allSourceLanguageCollection.filter((lang) => targetLang.code !== lang.code))
		let finalTargetLanguagesData = [...selectedTargetLanguageList, event];
		dispatchFinalDataToRedux('targetLanguages', finalTargetLanguagesData?.map(lan => ({...lan,label:lan.display})))
	};


	useEffect(()=>{
      if(followersCollectionData && followersCollectionData?.length > 0){
		getProjectFollowers(param.id)
	  }
	},[followersCollectionData])

	const removeFollower = (followerId) => {
		const removeMembers = members.filter(mem => mem.userId !== followerId)
		const availableMember = members.filter(mem => mem.userId === followerId)
		setMembers(removeMembers)
		setProjectFollowers([...projectFollowers, ...availableMember])
		let followers = removeMembers.map(data => ({
			applicationVersion: null,
			customerUser: data,
			id: null,
			path: null,
			projectWorkflowAssignee: false,
			reviewLanguages: null
		}))
		dispatchFinalDataToRedux('projectFollowers', followers)
		if($('.campaign-member-list .remove-btn').length === 1){
            setTimeout(()=>{
                $('.add-another').trigger('focus');
            },200)
          } else if($(document.activeElement).closest('li').is(':last-child')){
            setTimeout(()=>{
                $('.campaign-member-list li:last-child .remove-btn').trigger('focus');
            },200)
          }
	}

	const selectFollower = ({ selectedRows }) => {
		if (selectedRows && selectedRows.length > 0) {
			setFollowersToBeAdded(selectedRows);
		}
	}

	function hideModalSelectWorkflow() {
		setShowModalSelectWorkflow(false);
		document.body.classList.remove('modal-open');
		$('.add-another').trigger('focus');
	}

	function hideNewBidModal() {
		setNewBidModelStatus(false);
		document.body.classList.remove('modal-open');
		$(".stricy-btn > div:last-child div:last-child button").trigger("focus");
	}


	const columns = [
		{
			name: 'First Name',
			selector: row => row?.firstName,
			sortable: true,
		},
		{
			name: 'Last Name',
			selector: row => row?.lastName,
			sortable: true,
		},
		{
			name: 'Role',
			selector: row => row?.roleSet?.displayName,
			sortable: true,
		},
		{
			name: 'Languages',
			selector: row => row?.reviewLanguage !=="" ? row.reviewLanguage?.join(", ") : "None",
			sortable: true,
		}
	];
	const noDataFoundComponent = () => {
		return (
		  <div role="rowgroup">
			<div role="row" className="no-data-display align-center">
			  <div role="cell">
				<i className="nodata-icon"></i>
				<p>{Constants.NO_RECORD_FOUND}</p>
			  </div>
			</div>
		  </div>
		);
	  };


	const setPastCampaign = (event) => {
		let campaign = event?.value;
		if (campaign !== undefined && campaign !== null) {
			setPastCampaignStatus(event?.dueDateInPast);
			dispatchFinalDataToRedux('workspace', { id: campaign })
			if (campaign === -1) {
				dispatchFinalDataToRedux('workspace', { id: -1, name: null, dueDate: null })
				return
			}
		}
		else {
			if (campaign === undefined || campaign === null) {
				dispatchFinalDataToRedux('workspace', null)
			} else {
				dispatchFinalDataToRedux('workspace', { id: 0 })
			}
			setPastCampaignStatus(false);
		}

	}

	const projectEditableField = (status) => {
		switch (status) {
			case 'sync_content_to_translate':
				setProjectStatusEditableField(["name", "campaign", "description", "notes", "priority", "poNumber", "intendedUse", "reviewDueDate"])
				break;
			case 'in_translation':
				setProjectStatusEditableField(["name", "campaign", "description", "notes", "priority", "poNumber", "deliveryDueDate", "intendedUse", "reviewDueDate"])
				break;
				case 'cancelled':
				setProjectStatusEditableField(["name", "campaign", "description", "notes", "priority", "poNumber",  "intendedUse"])
				break;
				case 'project_closed':
				setProjectStatusEditableField(["name", "campaign", "description", "notes", "priority", "poNumber",  "intendedUse"])
				break;
				case 'waiting_for_source_update':
					setProjectStatusEditableField(["name","campaign","bidDueDate", "description", "notes", "priority", "poNumber",  "intendedUse","targetLanguages","deliveryDueDate"])
					break;
				case 'preparing_change_order_tm':
				setProjectStatusEditableField(["name", "campaign", "description", "notes", "priority", "deliveryDueDate","reviewDueDate","poNumber",  "intendedUse"])
				break;
				case 'internal_translator_rejected':
					setProjectStatusEditableField(["campaign", "priority"])
				break;
			case 'source_sync_failed':
				setProjectStatusEditableField(["campaign", "notes", "priority", "poNumber"])
				break;
			case 'all_languages_approved':
				setProjectStatusEditableField(["name", "campaign", "description", "notes", "priority", "poNumber", "intendedUse"])
				break;
			case 'waiting_for_bid_selection':
				setProjectStatusEditableField(["name", "campaign", "description", "notes", "priority", "poNumber", "deliveryDueDate", "bidDueDate", "targetLanguages", "intendedUse", "reviewDueDate"])
				break;
			case "submitted_for_bids":
				setProjectStatusEditableField(["name", "description", "campaign", "priority", "notes", "poNumber", "deliveryDueDate", "bidDueDate", "intendedUse", "reviewDueDate"])
				break;
			case "in_review":
				setProjectStatusEditableField(["name", "description", "notes", "campaign", "priority", "poNumber", "deliveryDueDate", "intendedUse", "reviewDueDate"])
				break;
			case "no_bids_submitted":
				setProjectStatusEditableField(['campaign','priority'])
				break;
			case "bid_selection_expired":
				setProjectStatusEditableField(["campaign", "priority"])
				break;
			case 'preparing_project_tm':
				setProjectStatusEditableField(["name", "description", "campaign","notes", "poNumber", "intendedUse", "reviewDueDate", "priority",])

				break;
			case "waiting_for_internal_translator_acceptance":
				setProjectStatusEditableField(["name","campaign", "description", "notes", "poNumber", "deliveryDueDate", "bidDueDate", "targetLanguages", "intendedUse", "reviewDueDate", "priority"])
				break;
			case "waiting_for_vendor_acceptance":
				setProjectStatusEditableField(["name", "description", "notes", "poNumber", "priority", "deliveryDueDate", "targetLanguages", "intendedUse", "reviewDueDate"])
				break;
			case "waiting_for_machine_translation_acceptance":
				setProjectStatusEditableField(["name", "description", "notes", "poNumber", "priority", "targetLanguages", "intendedUse"])
				break;
			case "change_order_requested":
				setProjectStatusEditableField(["name", "campaign", "description", "notes", "priority", "poNumber","deliveryDueDate","intendedUse"])
				break;
			case "in_cancellation_waiting_for_vendor":
				setProjectStatusEditableField(["name", "campaign", "description", "notes", "priority", "poNumber",  "intendedUse"])
				break;
		}

	}

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (refCalendar2.current && !refCalendar2.current.contains(event.target) && !refToggle2.current.contains(event.target)) {
				toggleIntialCalFlag(false);
			}
		};

		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
	}, [refCalendar2]);


	useEffect(() => {
		if (successMessage !== Constants.BLANK) {
			backToProject()
		}
	}, [successMessage])


	const priorities = [
		{ value: "HIGHEST", label: "Highest (1)" },
		{ value: "HIGH", label: "High (2)" },
		{ value: "MEDIUM", label: "Medium (3)" },
		{ value: "LOW", label: "Low (4)" },
		{ value: "LOWEST", label: "Lowest (5)" },
	]

	useEffect(() => {
		getProjectById(param.id)
		getIntendendUseTask()
		getAllSourceLanguages();
		getAllTargetLanguages();
		getAllDepartmennt()
		dispatch(updateProjectEditMessage({ editProjectSubmitStatus: false, ownerStatus: false, message: "" }));
	}, [])

	useEffect(()=>{
		if(projectWorkflows){
			addPresetReviewersToFollowersList();
		}
	},[projectWorkflows]);

	useEffect(()=>{
		if(customerPurchaseOrder.length === 0){
			getAllCustomerPurchaseOrder()
		}
	},[projectData?.currency]);

	const addPresetReviewersToFollowersList = () => {
		let elementsToBeAdded = [];
		projectWorkflows?.map((workflow) => {
		  workflow.steps.map((step) => {
			step.phases.map((phase) => {
			  if(phase.assigneeType.code === 'customer_user' && phase.assigneeUsers.length !== 0) {
				let userExists = checkIfUserIsFollower(phase.assigneeUsers[0].userId, elementsToBeAdded);
				if(userExists === 0) {
				  let elementRoleTypes = phase.assigneeUsers[0].roleSet.roleTypes.map((roleType) => roleType.displayName);
				  let elementToBeAdded = {
					id: phase.assigneeUsers[0].userId,
					label: phase.assigneeUsers[0].firstName + " " + phase.assigneeUsers[0].lastName,
					resource: {
					  "path" : "",
					  "applicationVersion" : "",
					  "id" : "",
					  "customerUser" : phase.assigneeUsers[0],
					  "reviewLanguages" : "",
					  "projectWorkflowAssignee" : false
					},
					roleSet: {
					  roleTypeList: undefined,
					  roleTypes: phase.assigneeUsers[0].roleSet.roleTypes
					},
					value: elementRoleTypes
				  }
				  elementsToBeAdded.push(elementToBeAdded);
				}
			  }
			})
		  })
		})
		setFollowerCollectionData(elementsToBeAdded)
	  }
	

	useEffect(() => {
		getWorkFlowStatus();
		if (projectStatus !== null) {
			projectEditableField(projectStatus?.code)
		}
	}, [projectStatus])

	useEffect(() => {
		setTimeout(() => {
			setErrorMessage("")
		}, 3000)
	}, [errorMessage])

	const checkIfUserIsFollower = (userId, addedFollowers) => {
		return projectFollowers?.followersCollection?.filter((follower) => follower.id === userId).length
				|| addedFollowers?.filter((follower) => follower.id === userId).length;
	  }

	useEffect(() => {
		if (targetLangCode !== "") {
			getAxiosResponse(APIUrls.INIT_CHANGE_ORDER_WORKFLOW(param.id) + `?language=${targetLangCode}`).then(res => {
				let displayNameData = res.data.data[0]?.displayName[0]
				let resourceData = res.data.data[0]?.resource
				let data = { displayName: [...projectWorkflow.value.displayName, displayNameData], resource: [...projectWorkflow.value.resource, resourceData] }
				dispatch(updateInitializedProjectWorkflows(data));
			}).catch(err => {
				handleError(err)
			})
		}
	}, [targetLangCode])


    useEffect(() => {
		let deliveryDueTime;
        getAllProjectFollowers()
        workSpaceTags()
        getAllProjectOwner()
		if (projectData.deliveryDueDate) {
            deliveryDueTime=utcDateTimeWithTimeZone(projectData?.deliveryDueDate?.utcTimestamp, userTimeZone).hour();
            setDeliveryDueTime(deliveryDueTime)
            setProjectDeliveryDueDate(projectData?.deliveryDueDate?._d)
        }
        if (projectData?.bidDueDate) {
        	const bidDueTime=utcDateTimeWithTimeZone(projectData?.bidDueDate?.utcTimestamp, userTimeZone).hour()
            setBidDueTime(bidDueTime)
            setProjectBidDueDate(projectData?.bidDueDate?._d)
        }
        getProjectMembership()
    }, [projectDataCount])

	useEffect(() => {
		if (projectData.projectFollowers && projectFollowers.length > 0) {
			let followers = projectFollowers?.filter(y => !projectData.projectFollowers.some(x => x?.customerUser?.userId === y?.userId))
			setProjectFollowers(followers)
		}
	}, [followersCount])

	useEffect(() => {
		if (projectInfo !=="" && projectInfo?.targetLanguages && targetLanguage?.length > 0) {
			setSelectedTargetLanguageList(targetLanguage.filter(lang => projectInfo?.targetLanguages?.includes(lang?.language)));
			let finalTargetLanguages = targetLanguage.filter(y => !projectInfo?.targetLanguages.some(x => x === y.language))
			setTargetLanguage(finalTargetLanguages.filter(lang => lang?.language !== projectInfo?.sourceLanguage))
		}
	}, [targetLanguageCount,projectInfo])


	useEffect(() => {
		if (projectInfo  !=="" &&  projectInfo?.sourceLanguage ) {
			setSelectedSourceLanguage(sourceLanguage.filter(lang => lang?.language==projectInfo?.sourceLanguage)[0]);
		}
	}, [sourcelanguageCount,projectInfo])

	const getAllTargetLanguages = () => {
		getAxiosResponse(APIUrls.TARGET_LANGUAGE).then(res => {
			const targetLang = transformBlankToNull(res.data.data);
			if (targetLang && targetLang?.length > 0) {
				setTargetLanguage(targetLang.map(data=>({...data,label:data.display})));
				setAllTargetLanguageCollection(targetLang?.map(data=>({...data,label:data.display})))
				setTargetLanguageCount(targetLang)
			}
		}).catch(err => {
			handleError(err)
		})

	}

	useEffect(() => {
		if(bumpDeliveryDueDate) {
			bumpDeliveryDueDateIfNecessary();
		}
	}, [bumpDeliveryDueDate])

	useEffect(() => {
		if(calculateBidSelectionDeadline) {
			var newBidSelectDeadline = calculateBidSelectionDeadlineDate();
			if(newBidSelectDeadline) {
				setBidSelectDeadlineDate(newBidSelectDeadline);
				dispatchFinalDataToRedux('bidSelectDeadlineDate', timeStamp(newBidSelectDeadline, userTimeZone));
			}
		}
		setCalculateBidSelectionDeadline(false);
	}, [calculateBidSelectionDeadline]);

	useEffect(() => {
		if(invokeDateChanged) {
			if(projectData.bidDueDate) {
				var bidDue = new Date(dateUtil.convertToLocalDateTimestamp(projectData.bidDueDate));
				bidDue.setHours(bidDueTime);
				onDateChanged(timeStamp(bidDue, userTimeZone));
			}
		}
	}, [invokeDateChanged])

	useEffect(() => {
		getDefaultProjectFollowers()
	}, [])

	const getDefaultProjectFollowers=()=>{
		getAxiosResponse(APIUrls.DEFAULT_FOLLOWERS_BY_GROUP(projectData?.userGroup?.id))
		.then((res) => {
			if (res.data.code === 200) {
				if(res?.data?.data){
					const options = res?.data?.data.map(({ resource, displayName }) => ({
						label: resource?.firstName + " " + resource?.lastName,
						value: displayName,
						id: resource?.userId,
						resource: resource,
						roleSet: {
							roleTypes: resource?.roleSet?.roleTypes,
							roleTypeList: resource?.roleSet?.roleTypeList
						}
					}));
					dispatch(updateFollowersCollection(options));
				}
			}
		})
		.catch((err) => {
			handleError(err);

		});
	}

	useEffect(() => {
		getProjectMembership()
		getDefaultProjectFollowers()
	}, [projectData?.userGroup?.id])

	const projectFollowersData=()=>{
		setDepId(projectData?.userGroup?.id)
		Promise.all([
			getAxiosResponse(APIUrls.PROJECT_FOLLOWERS_BY_GROUP(projectData?.userGroup?.id) + `?projectId=${param.id}`),
			getAxiosResponse(APIUrls.DEFAULT_FOLLOWERS_BY_GROUP(projectData?.userGroup?.id)),
		]).then(async([result,res]) => { 
		var	followersCollection=null;
		var allProjectFollowersCollection=null;
			if (result?.data?.data && result?.data?.data?.length > 0) {
				const followers = result?.data?.data.map(data => ({ ...data?.resource?.customerUser, reviewLanguage: data?.resource.reviewLanguages }))
				setProjectFollowers(followers)
				setProjectFollowersCount(followers)
				setToggleCleared(false)
				allProjectFollowersCollection=followers
			}
			if (res.data.code === 200) {
				const options = res?.data?.data.map(({ resource, displayName }) => ({
					label: resource?.firstName + " " + resource?.lastName,
					value: displayName,
					id: resource?.userId,
					resource: resource,
					roleSet: {
						roleTypes: resource?.roleSet?.roleTypes,
						roleTypeList: resource?.roleSet?.roleTypeList
					}
				}));
				followersCollection=options;
				dispatch(updateFollowersCollection(options));
				if(members && members.length > 0){
				let mem=members.filter(data =>data.removable)
				let availableFollowers=[...mem]
				var defaultMember=res?.data?.data?.map(data=>({...data?.resource?.customerUser,removable:true}))
				defaultMember.forEach(res=>{
					if((availableFollowers && availableFollowers?.length && availableFollowers?.findIndex(data => data.userId ===res.userId) !==-1)){
						res.removable=false
					}else{
						let obj={...res,removable:false}
						availableFollowers.push(obj)
					}
				})
			let membersData=availableFollowers.filter(data=>data?.userId === projectData?.owner?.userId)
				if(membersData && membersData.length > 0){
				setMembers([...availableFollowers])
				} else{
					let owner={...projectData?.owner,removable:true }
					setMembers([...availableFollowers,owner])
				}
			}
			}
			
		}).catch(err=>{
			console.error(err)
		})

	}

	useEffect(() => {
		dispatchFinalDataToRedux('projectWorkflows', projectWorkflows)
		getAllAvaialableWorkflows()
	}, [projectWorkflows])

	const getAllAvaialableWorkflows = () => {
		getAxiosResponse(APIUrls.AVAILABLE_WORKFLOWS(param.id))
			.then((res) => {
				if (res.data.code === 200) {
					let options = res.data.data;
					options.forEach(obj => {
						if (obj.name === projectWorkflows[0]?.templateName) {
							dispatch(updateSelectedProjectWorkflow(obj));

							getAxiosResponse(APIUrls.INITIALIZED_PROJECT_WORKFLOWS(param.id, obj.id))
								.then((res) => {
									if (res.data.code === 200) {
										//  dispatch(updateInitializedProjectWorkflows(res.data.data));
									}
								})
								.catch((err) => {
									handleError(err);
								})
						}
					})
				}
			})
			.catch((err) => {
				handleError(err)
			});
	}

	const getProjectMembership = () => {
		getAxiosResponse(APIUrls.PROJECT_MEMBERSHIP(projectData?.userGroup?.id)).then(result => {
			if (result.data.data && result.data.data.totalUsers === 1) {
				setSelected("setlanguage");
			} else {
				setSelected("reviewDuedate");
			}
		}).catch(err => {
			handleError(err)
		})

	}

	const getProjectFollowers = (id) => {
		getAxiosResponse(APIUrls.CUSTOMER_PROJECT_FOLLOWERS(id)).then(result => {
			if (result?.data?.data && result?.data?.data?.length > 0) {
				let  followers = result?.data?.data.map(data => ({ ...data.resource, reviewLanguage: data?.reviewLanguage }))
				followers.forEach((data,index)=>{
                   if(data?.userId===followersCollectionData?.find(res=>res?.id===data?.userId)?.id){
					data.removable=true;
				   }else{
					data.removable=false;
				   }

				})
				setMembers(followers)
			}
		}).catch(err => {
			handleError(err)
		})
	}

	const confirmDelete = () => {
		setTimeout(() => {
		  $("#deleteNo").trigger("focus");
		  $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Confirm Delete"} );
		}, 500);
		confirmAlert({
		  title: "Infomation",
		  message: <p>{`Please update the Source file before making any changes!`}</p>,
		  buttons: [
			{
			  label: "Ok",
			  id: "deleteNo",
			  onClick: () => {
				$('.focusAdd').trigger('focus');
				$('.delete-icon').removeClass('focusAdd');
			  },
			  onKeyDown: (e) => {
				if (e.key === "Tab") {
				  if (e.shiftKey === false) {
					e.preventDefault();
					$("#deleteYes").trigger("focus");
				  }
				}
				if (e.key === Constants.ESCAPE) {
				  $('.focusAdd').trigger('focus');
				  $('.delete-icon').removeClass('focusAdd');
				}
			  },
			},
		  ],
		  closeOnEscape: true,
		  closeOnClickOutside: true,
		  overlayClassName: "delete_overlay",
		});
	  };


	const getWorkflowStatusForQuery = () => {
		if (projectStatus?.cancelled || projectStatus?.inCancellation) {
			return "CANCELLED";
		}
		if (!projectStatus?.bidSelected) {
			return "PENDING";
		}
		if (projectStatus?.closed) {
			return "COMPLETED";
		}
		return "OPEN,COMPLETED";
	}

	const getWorkFlowStatus = () => {
		const status = getWorkflowStatusForQuery();
		getAxiosResponse(APIUrls.EXISTING_PROJECT_WORKFLOW(param.id, status)).then(result => {
			if (result?.data?.data && result.data.data?.length > 0) {
				var actualWorkflows = result?.data?.data.map(function (item) { return item["resource"]; });
				const displayNameArray = result?.data?.data?.map(item => item.displayName[0]);
				setprojectWorkflows(actualWorkflows)
				if (actualWorkflows && actualWorkflows.length > 0) {
					let data = { displayName: displayNameArray, resource: actualWorkflows }
					dispatch(updateInitializedProjectWorkflows(data));
					getAxiosResponse(APIUrls.INITIALIZED_PROJECT_WORKFLOWS(param.id, actualWorkflows[0].id))
						.then((res) => {
							if (res.data.code === 200) {

							}
						})
						.catch((err) => {
							handleError(err);
						})
				}
			}
		}).catch(err => {
			handleError(err)
		})

	}

	const getAllProjectFollowers = () => {
		if (projectData.userGroup?.id) {
			setDepId(projectData.userGroup?.id)
			getAxiosResponse(APIUrls.PROJECT_FOLLOWERS_BY_GROUP(projectData?.userGroup?.id) + `?projectId=${param.id}`).then(result => {
				if (result?.data?.data && result?.data?.data?.length > 0) {
					const followers = result?.data?.data.map(data => ({ ...data?.resource?.customerUser, reviewLanguage: data?.resource.reviewLanguages }))
					setProjectFollowers(followers)
					setProjectFollowersCount(followers)
					setToggleCleared(false)
				}
			}).catch(err => {
				handleError(err)
			})

		}
	}

	const getAllProjectFollowersByDepId = (departmentId) => {
		if (departmentId !== null) {
			getAxiosResponse(APIUrls.PROJECT_FOLLOWERS_BY_GROUP(departmentId)).then(result => {
				if (result?.data?.data && result?.data?.data?.length > 0) {
					const followers = result?.data?.data.map(data => ({ ...data.resource.customerUser, reviewLanguage: data?.reviewLanguage }))
					setProjectFollowers(followers)
				}
			}).catch(err => {
				handleError(err)
			})

		}
	}


	const handleChange = (event, occurence) => {
		if (occurence === 'priority') {
			if (event) {
				dispatchFinalDataToRedux('priority', event.value)
			} else {
				dispatchFinalDataToRedux('priority', null)
			}
		}
		else if (occurence === 'intendedUse') {
			if (event.value == 0) {
				dispatchFinalDataToRedux('intendedUse', "")
				return
			} else {
				dispatchFinalDataToRedux('intendedUse', { id: event.id, name: event.value })

			}
		}
	}

	useEffect(()=>{
        if(projectData?.userGroup?.id){
			getAllProjectOwner()
			projectFollowersData()
		}
	},[projectData?.userGroup?.id])

	const getAllProjectOwner = () => {
		if (projectData?.userGroup) {
			getAxiosResponse(APIUrls.PROJECT_OWNER(projectData?.userGroup?.id)).then(res => {
				const options = res.data.data && res.data.data.length > 0 && res.data.data.map(data => ({
					label: data.firstName + " " + data.lastName,
					value: data.userId,
					followers: data
				}));
				setProjectOwner(options)
				setOwnerLoading(false)
				showGlobalOverlay(false)
			}).catch(err => {
				handleError(err)
				showGlobalOverlay(false)
			})

		}

	}


	const getIntendendUseTask = () => {
		getAxiosResponse(APIUrls.INTENDED_USE).then(res => {
			const intendendUseTaskData = res?.data?.data && res?.data?.data.length > 0 && res?.data?.data.map(({ id, name }) => ({
				label: name,
				value: name,
				id: id
			}));
			if (intendendUseTaskData) {
				intendendUseTaskData.unshift({
					label: 'Select one',
					value: 0,
					id: 0
				})
			}
			setIntendedUseTask(intendendUseTaskData)
		}).catch(err => {
			handleError(err)
		})
	}


	const getAllCampaign = () => {
		let workspaceQueryParam = '?onlyMember=true&onlyOpen=true'
		workspaceQueryParam = workspaceQueryParam
		getAxiosResponse(APIUrls.WORKSPACE_LIST + workspaceQueryParam).then(campaignResult => {
			if (campaignResult?.data?.data?.result
				&& campaignResult?.data?.data?.result.length > 0) {
				const campaignDataResult =
					campaignResult?.data?.data?.result.map(({ id, name, dueDateInPast }) => ({
						label: name,
						value: id,
						id: id,
						dueDateInPast: dueDateInPast
					}));
				if (campaignDataResult) {

					campaignDataResult.unshift({
						label: 'Select a Campaign',
						value: 0,
						id: 0,
						dueDateInPast: false
					})

				}
				setWorkspaceCampaign(campaignDataResult)
			} else {

				let selectCampaign = {
					label: 'Select a Campaign',
					value: 0,
					id: 0,
					dueDateInPast: false
				}
				setWorkspaceCampaign([selectCampaign])
			}
		}).catch(err => {
			handleError(err)
		})
	}

	const getProjectById = (projectId) => {
        getAxiosResponse(APIUrls.PROJECT_DETAILS_WITH_CUSTOM_DATE(projectId))
            .then((result) => {
                if (result.data.code === 200) {
                    getAllCampaign(result?.data?.data)
					let dates=result?.data?.data?.displayName[0]
                    setProjectStatus(result?.data?.data?.status)
                    let projectData = result?.data?.data?.resource?.projectResource;
                    setProjectOwnerData(projectData?.owner)
                    projectData['projectName'] = projectData?.name;
					if(dates?.bidDueDate !==""){
						projectData['bidDueDate'] =dates?.bidDueDate
					}if(dates?.deliveryDueDate !==""){
						projectData['deliveryDueDate'] =dates?.deliveryDueDate
					}if(dates?.bidSelectionDeadlineDate !==""){
						 projectData['bidSelectDeadlineDate']=dates?.bidSelectionDeadlineDate
					}
                    
                    if (projectData?.deliveryDueDate !=="") {
                        setMinDueDate(getDateTimestamp(projectData?.bidDueDate))
                    }
                    dispatch(updateProjectInfo(projectData))
                    setProjectInfo(projectData)
                    setProjectCount(transformBlankToNull(projectData))
                    setProjectDepartmentId(projectData?.userGroup?.id)
                    setOwnerData(projectData?.owner)
                    setIntendedUseData(projectData?.intendedUse)
                    setTargetDate(projectData?.deliveryDueDate)
                        setMembers(projectData?.projectFollowers?.map(data =>data?.customerUser))

                }
            })
            .catch((err) => {
                handleError(err);
            });
    }

	const handleTagsChange = (event) => {
		if (event.key === Constants.ENTER) {
			let value = event?.target?.value.trim();
			if (!value) return;
			let finalData = tagsData.filter(data => data === value)
			if (finalData[0] !== value) {
				setTagsData([...tagsData, value]);
				let tagsDropdownData = tagsDropdown.filter(data => data.value !== value);
				setTagsDropdown(tagsDropdownData)
			}
			if (event) {
				dispatchFinalDataToRedux('tags', [...tagsData, value])
			}
		} else {
			let value = event[0]?.value
			if (value) {
				setTagsData([...tagsData, value]);
				let tagsDropdownData = tagsDropdown.filter(data => data.value !== value);
				setTagsDropdown(tagsDropdownData)
				if (event) {
					dispatchFinalDataToRedux('tags', [...tagsData, value])
				}
			}
		}
	};

	const clearTags = (e, tags) => {
		let finalTagData = tagsData.filter(data => data !== tags)
		let finalTag = tagsData.filter(data => data === tags)
		setTagsData(finalTagData)
		tagsCheck.forEach(data => {
			if (data.value === tags) {
				setTagsDropdown([...tagsDropdown, { label: finalTag[0], value: finalTag[0] }])
			}
		})
		dispatchFinalDataToRedux('tags', finalTagData)

		const selectedElement = $(document.activeElement).closest(".multiselect-output");
		if ($(document.activeElement).is(':last-child') &&
			selectedElement.children().length > 1) {
			selectedElement.find('button:nth-last-child(2)').trigger('focus');
		} else if ($(document.activeElement).is(':last-child')) {
			$(document.activeElement).closest(".global-dropdown-block").find('input:first-of-type').trigger('focus');
		}

	}

	const clearTagsonKeydown =(e, tags)=>{
		if (event.key === Constants.ENTER) {
			clearTags(e,tags);
		}
	}
	const workSpaceTags = () => {
		getAxiosResponse(APIUrls.WORKSPACE_TAGS).then(allTags => {
			if (projectData?.tags?.length > 0) {
				const allTagsData = allTags.data.data.result.map(obj => {
					return {
						label: obj.display,
						value: obj.display
					}
				})
				let finalTags = allTagsData.filter(y => !projectData?.tags.some(x => x === y.value))
				setTagsDropdown(finalTags)
				setTagsData(projectData?.tags)
				setTagsCheck(allTagsData)
			} else {
				const allTagsData = allTags.data.data.result.map(obj => {
					return {
						label: obj.display,
						value: obj.display
					}
				})
				setTagsDropdown(allTagsData)
				setTagsCheck(allTagsData)
			}
		}).catch(err => {

		})
	}

	const fieldChange = (event) => {
		dispatchFinalDataToRedux(event.target.name, event.target.value)
	}


	const setOwner = (event) => {
		dispatchFinalDataToRedux("owner", event?.followers)
		let followers = {
			applicationVersion: null,
			customerUser: event?.followers,
			id: null,
			path: null,
			projectWorkflowAssignee: false,
			reviewLanguages: null
		}
		const result = members.filter(data => data.userId === event?.followers?.userId)
		if (result.length === 0) {
			let finalMembers = members.map(data => ({
				applicationVersion: null,
				customerUser: data,
				id: null,
				path: null,
				projectWorkflowAssignee: false,
				reviewLanguages: null
			}))
			let localMember=[...members, event?.followers].filter(data=>data.userId !==event?.followers.userId)

			setMembers([...localMember, event?.followers])
			dispatchFinalDataToRedux('projectFollowers', [...finalMembers, followers])
		}

	}

	const setCustomerPO = (event) => {
		const po = customerPurchaseOrderData.filter(data => data?.id == event?.value)
		if (po.length > 0) {
			dispatchFinalDataToRedux("purchaseOrder", po[0])
		} else {
			dispatchFinalDataToRedux("purchaseOrder", null)
		}
	}

	const getAllDepartmennt = () => {
		if (!roleArray.includes('ROLE_VENDOR')) {
			getAxiosResponse(APIUrls.DEPARTMENT_URL)
				.then((res) => {
					if (res.data.code === 200) {
						if (res?.data?.data && res?.data?.data.length > 0) {
							const options =
								res.data.data.map(({ id, name }) => ({
									label: name,
									value: id,
								}))?.filter(data=>data?.label !=="Unassigned")
							updateDepartment(options);
						}
					}
				})
				.catch((err) => {
					handleError(err);
				});
		}
	}

	const getAllSourceLanguages = () => {
		getAxiosResponse(APIUrls.SOURCE_LANGUAGE).then(res => {
			const sourceLang = transformBlankToNull(res.data.data);
			if (sourceLang && sourceLang.length > 0) {
				setSourceLanguage(sourceLang?.map(data=>({...data,label:data?.display})));
				setAllSourceLanguageCollection(sourceLang?.map(data=>({...data,label:data?.display})));
				setSourceLanguageCount(sourceLang?.map(data=>({...data,label:data?.display})))
			}
		}).catch(err => {
			handleError(err)
		})

	}

	const getAllCustomerPurchaseOrder = () => {
		getAxiosResponse(APIUrls.CUSTOMER_PURCHASE_ORDER).then(result => {
			setCustomerPurchaseOrderData(result?.data?.data)
			let data=result?.data?.data;
			if (data && data?.length > 0) {
				let finalResult=data?.filter(o=>o?.currency===projectData?.currency)
				.map(({ shortDisplay, id }) => ({
					value: id,
					label: shortDisplay
				}));
				setCustomerPurchaseOrder(finalResult)
			}
		}).catch(err => {
			handleError(err)
		})

	}

	const showCalendarDueDate = () => {
		toggle ? toggleCal(false) : toggleCal(true);
		$('#calFirstFocus').toggleClass('calFirstFocus')
		$('.calFirstFocus').trigger('focus')
		$(document).mouseup(function(e) {
		  var bannerCont = $('.firstCal');
		  if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
			toggleCal(false)
			$('#calFirstFocus').removeClass('calFirstFocus')
		 }
		});
		if (toggle) {
			var requiredElement = document.querySelector(".dashCalendarDeadLine");
			requiredElement?.focus();
		}
	};
	$("#calFirstFocus").on("keydown", function (e) {
		if (e.key === Constants.ESCAPE) {
		  if($('div').hasClass('dashCalendarDeadLine')){
			toggleCal(false)
			$('.calFirstFocus').trigger('focus')
			$('#calFirstFocus').removeClass('calFirstFocus')
		   }
		 }
		 if (e.key === Constants.TAB && e.shiftKey) {
		  if($('div').hasClass('dashCalendarDeadLine')){
			toggleCal(false)
			$('.calFirstFocus').trigger('focus')
			$('#calFirstFocus').removeClass('calFirstFocus')
		   }
		 }
	});
	const handleEscFocus = (event) => {
		if (event.key === Constants.ESCAPE) {
		  toggleCal(false)
			$('.calFirstFocus').trigger('focus')
			$('#calFirstFocus').removeClass('calFirstFocus')
		}
     }
	const showCalendarDeliveryDate = () => {
		toggleIntialCal ? toggleIntialCalFlag(false) : toggleIntialCalFlag(true);
		$('#calSecondFocus').toggleClass('calSecondFocus')
		$('.calSecondFocus').trigger('focus')
		$(document).mouseup(function(e) {
		  var bannerCont = $('.caltopset');
		  if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
			toggleIntialCalFlag(false)
			$('#calSecondFocus').removeClass('calSecondFocus')
		 }
		 });
		if (toggleIntialCal) {
			var requiredElement = document.querySelector(".dashCalendarMachine2");
			requiredElement?.focus();
		}
	};
	$("#calSecondFocus").on("keydown", function (e) {
		if (e.key === Constants.ESCAPE) {
		  if($('div').hasClass('dashCalendarMachine2')){
			toggleIntialCalFlag(false)
			$('.calSecondFocus').trigger('focus')
			$('#calSecondFocus').removeClass('calSecondFocus')
		   }
		 }
		 if (e.key === Constants.TAB && e.shiftKey) {
		  if($('div').hasClass('dashCalendarMachine2')){
			toggleIntialCalFlag(false)
			$('.calSecondFocus').trigger('focus')
			$('#calSecondFocus').removeClass('calSecondFocus')
		   }
		 }
	   });
	   const handleEscFocus2 = (event) => {
		if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'true') {
			toggleIntialCalFlag(false)
			$('.calSecondFocus').trigger('focus')
			$('#calSecondFocus').removeClass('calSecondFocus')
		}
	  }
	const closeCalendar = (e) => {
		if (e.code === "Escape") {
			toggleCal(false);
			$('.calFirstFocus').trigger('focus')
			$('#calFirstFocus').removeClass('calFirstFocus')
		}
	};
	const closeCalendar2 = (e) => {
		if (e.code === "Escape") {
		toggleIntialCalFlag(false);
		  $('.calSecondFocus').trigger('focus')
		   $('#calSecondFocus').removeClass('calSecondFocus')
		}
	  };


	  const setDueDate = (event) => {
        toggleCal(false)
        var deliveryDueDate=new Date(event)
        setMinDueDate(deliveryDueDate.getTime())
        deliveryDueDate.setHours(bidDueTime)
        dispatchFinalDataToRedux('bidDueDate', event)
        dispatchFinalDataToRedux('bidDueDateChanged', true)
        const deliveryDueDates=new Date(projectData.deliveryDueDate)
        deliveryDueDates.setHours(bidDueTime)
             let hour=getHourDifference(event,deliveryDueDates)
             let day=getDayDifference(event,deliveryDueDates)
           if(day < 1 ){
            if(hour >= 24 ){
                deliveryDueDate.setDate(deliveryDueDate.getDate()+1)
            setProjectDeliveryDueDate(deliveryDueDate);

            }else{
                deliveryDueDate.setDate(deliveryDueDate.getDate()+2)
            setProjectDeliveryDueDate(deliveryDueDate);

            }
            dispatchFinalDataToRedux('deliveryDueDate', deliveryDueDate)
            dispatchFinalDataToRedux('deliveryDueDateChanged', true)
            toggleCal(false)
            setBidDueTime(bidDueTime);
            setProjectBidDueDate(event);
           }else{
            setBidDueTime(bidDueTime);
            setProjectBidDueDate(deliveryDueDate);
           }

        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
    }
	

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				refCalendar.current &&
				!refCalendar.current?.contains(event.target) &&
				!refToggle.current?.contains(event.target)
			) {
				toggleCal(false);
			}
		};

		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
	}, [refCalendar]);

	const onSubmit = event => {
		event.preventDefault()
		if (projectData?.intendedUse === "") {
			setInvalidIntendedUse(true)
			setTimeout(() => {
				var tmpval = $('#user-error').val();
				if(tmpval == '') {
				$('.intendentUse .cw__input').trigger('focus')
				}
			}, 200);
			return
		}

		if( projectStatus?.code !== 'cancelled' && projectData?.projectVendorType !== "EXTERNAL_BIDLESS" && projectData?.projectVendorType !=='INTERNAL' && projectData?.projectVendorType !=='MACHINE_TRANSLATION') {
			if (!(projectStatus?.code === "in_review" || projectStatus?.code === "in_translation" || projectStatus?.code === "change_order_requested")) {
				if (projectData?.intendedUse?.name !== intendedUseData?.name) {
					displayNewBidModel()
					return;
				}
				if (projectData?.deliveryDueDate !== targetDate) {
					displayNewBidModel()
					return;
				}
				if (projectData?.targetLanguages?.length === 0) {
					return;
				}
				if (targetLangCode !== "") {
					displayNewBidModel()
					return;
				}
			}
		}
         
		if(projectStatus?.code === "waiting_for_source_update"){
               confirmDelete()
			return
		}

		setInvalidIntendedUse(false)
		updateProject(projectData);
	}

	const setDepartment = (event) => {
		setDepId(event?.value)
     	getAllProjectFollowersByDepId(event.value)
		dispatchFinalDataToRedux('userGroup', { id: event.value, name: event.label })
	    let	owner={label:`${projectOwnerData.firstName +" "+ projectOwnerData.lastName}`,value:projectOwnerData?.userId ,followers:projectOwnerData}
		setOwner(owner)
	}

	const updateProject = (updateProjectFinal) => {
		  if(!(projectStatus?.inBidOut) && projectData.poRequired){
			  if(projectData.purchaseOrder ==="" || projectData.purchaseOrder ===null){
                setPurchaseOrderRequired(true) 
				return 
			  }
		  }
		  setPurchaseOrderRequired(false) 
		hideNewBidModal()
		showGlobalOverlay(true)
		updateProjectFinal = { ...updateProjectFinal, "projectWorkflows": projectWorkflowsData }
		let newProjectData={...updateProjectFinal}
				if(newProjectData?.bidDueDate){
			newProjectData={...newProjectData,'bidDueDate':newProjectData?.bidDueDate?.utcTimestamp?getTimeStamp(newProjectData?.bidDueDate?.utcTimestamp):timeStamp(newProjectData?.bidDueDate?.dateWithTime?newProjectData?.bidDueDate?.dateWithTime:newProjectData?.bidDueDate,userTimeZone)}
		}
		if(newProjectData?.deliveryDueDate){
			newProjectData={...newProjectData,'deliveryDueDate':newProjectData?.deliveryDueDate?.utcTimestamp?getTimeStamp(newProjectData?.deliveryDueDate?.utcTimestamp): timeStamp(newProjectData?.deliveryDueDate?.dateWithTime?newProjectData?.deliveryDueDate?.dateWithTime:newProjectData?.deliveryDueDate,userTimeZone)}
		}
		if(newProjectData?.bidSelectDeadlineDate){
			newProjectData={...newProjectData,'bidSelectDeadlineDate':newProjectData?.bidSelectDeadlineDate?.utcTimestamp?getTimeStamp(newProjectData?.bidSelectDeadlineDate?.utcTimestamp):timeStamp(newProjectData?.bidSelectDeadlineDate?.dateWithTime?newProjectData?.bidSelectDeadlineDate?.dateWithTime:newProjectData?.bidSelectDeadlineDate,userTimeZone)}
		}

		newProjectData = { ...newProjectData, 'targetLanguages': newProjectData.targetLanguages.map(n => n.language) };

		let targetLanguageUndefinedCount = newProjectData?.targetLanguages?.filter(data => data === undefined).length

		if (targetLanguageUndefinedCount > 0) {
			newProjectData = { ...newProjectData, 'targetLanguages': projectWorkflowsData.map(lang => lang.language) };
		}


		putAxiosResponse(APIUrls.PROJECT_DETAILS_WITH_CUSTOM_DATE(param.id),transformBlankToNull(newProjectData)).then((res) => {
			if (res.data?.data?.body?.errors|| res.data?.data?.handledMessage) {
				let message = res.data?.data?.body?.errors? Object.values(res.data?.data?.body?.errors).join('<br>') : res.data?.data?.handledMessage;
				setErrorMessage(message);
			} else if (res.data.code === 200) {
				if (res.data?.data?.resource !== undefined) {
					setSuccessMessage(Constants.PROJECT_UPDATE_SUCCESS_MESSAGE);
					showGlobalOverlay(false)
					if (projectData?.owner?.userId !== ownerData?.userId) {
						let name = projectData?.owner?.firstName + " " + projectData?.owner?.lastName
						dispatchProjectEditMessageRedux({ ...projectEditMessage, ownerStatus: true, editProjectSubmitStatus: false, message: Constants.PROJECT_OWNER_UPDATE_MESSAGE(name) })
					} else {
						dispatchProjectEditMessageRedux({ ...projectEditMessage, editProjectSubmitStatus: true, ownerStatus: false })
					}
				}
				else{
					let message=[];
					let data=res?.data?.data?.body?.errors;
					   if(Object?.keys(data)?.length === 0){
						setSuccessMessage(Constants.PROJECT_UPDATE_SUCCESS_MESSAGE);
						showGlobalOverlay(false)
						if(projectData?.owner?.userId !==ownerData?.userId){
							let name=projectData?.owner?.firstName +" "+projectData?.owner?.lastName
						dispatchProjectEditMessageRedux({...projectEditMessage,ownerStatus:true,editProjectSubmitStatus:false,message:Constants.PROJECT_OWNER_UPDATE_MESSAGE(name  )})
						}else{
						dispatchProjectEditMessageRedux({...projectEditMessage,editProjectSubmitStatus:true,ownerStatus:false})
						}
					   }else{
                    for(let i=0;i<=Object?.keys(data).length;i++){
						if(Object?.keys(data)[i] !=="" && Object?.keys(data)[i] !==undefined){
							let details = Object?.keys(data)[i].split("_");
							let errorLang = projectWorkflowDisplayNameData?.filter((data) => data?.code === details[0]?.split(".")[2]);
                        	if(errorLang && errorLang.length > 0) {
									message.push(data[Object?.keys(data)[i]] + " in language schedule " + errorLang[0]?.display + ", for step " + details[1] + " phase " + details[2] + ".")
							} else {
								message.push(data[Object?.keys(data)[i]]);
							}
						}
					}
					if(message.length > 1) {
						message = message.join('<br>');
					}
					setErrorMessage(message)
				}
				}

			}

			showGlobalOverlay(false)
		})
			.catch((err) => {
				handleError(err);
				showGlobalOverlay(false)
			});
	}

	const backToProject = () => {
		navigate(`/project/${param.id}`);
	}

	const handleBackToProject = (e) => {
		if (e.key===Constants.ENTER) {
			navigate(`/project/${param.id}`);
		}
	}

	useEffect(() => {
		if (projectData) {
			if (projectData.name === '' || projectData.intendedUse === null || projectData.userGroup === null || projectData.owner === null || projectData.deliveryDueDate === null ) {
				setDisableButton(true);
			}
		} else {
			setDisableButton(false);
		}
	}, [disableButton]);

	const cancelProjectAndNavigateToDashboard = () => {
		dispatchFinalDataToRedux('status', 'CANCELLED')
		dispatchFinalDataToRedux('statusCode', 'cancelled')
		setInitiateCancelOrSaveExitProject(true);
	}

	useEffect(() => {
		if (initiateCancelOrSaveExitProject) {
			showGlobalOverlay(true)
			putAxiosResponse(APIUrls.PROJECT(param.id), transformBlankToNull(projectData)).then((res) => {
				if (res.data.code === 200) {
					showGlobalOverlay(false)
					backToProject()
				}
				showGlobalOverlay(false)
			})
				.catch((err) => {
					handleError(err);
					showGlobalOverlay(false)
				});
		}
	}, [initiateCancelOrSaveExitProject])

	const cancelProject = () => {
		$(document.activeElement).addClass('projectCancel');
		setTimeout(() => {
		  $("#react-confirm-alert").attr({
			'aria-modal': 'true',
			'role': 'dialog',
			'aria-labelledby':"cancelProject"
			});
			$("h1").attr({
			'id': 'cancelProject',
		   });
		  }, 200);
		setTimeout(() => {
			$('#yes-cancel').trigger('focus');
		}, 500);
		confirmAlert({
			title: `${t('label_cancel_project')}`,
			message: <p>{`${t('cancel_project_confrm_message')}`}</p>,
			buttons: [
				{
					label: `${t('button_yes')}`,
					id: 'yes-cancel',
					onClick: () => cancelProjectAndNavigateToDashboard(),
					onKeyDown: (e) => {
						if (e.key === Constants.TAB) {
							if (e.shiftKey === true) {
								e.preventDefault()
								$('#no-cancel').trigger('focus');
							}
						} else if (e.key === Constants.ESCAPE) {
							$('.projectCancel').trigger('focus');
							$('.projectCancel').removeClass('projectCancel');
						  }
					}
				},
				{
					label: `${t('button_no')}`,
					id: 'no-cancel',
					onClick: () => {
						$('.projectCancel').trigger('focus');
						$('.projectCancel').removeClass('projectCancel');
					},
					onKeyDown: (e) => {
						if (e.key === Constants.TAB) {
							if (e.shiftKey === false) {
								e.preventDefault()
								$('#yes-cancel').trigger('focus');
							}
						} else if (e.key === Constants.ESCAPE) {
						  $('.projectCancel').trigger('focus');
						  $('.projectCancel').removeClass('projectCancel');
						}
					}
				}
			],
			closeOnEscape: true,
			closeOnClickOutside: true,
			overlayClassName: "delete_overlay"
		});
	}

	const crumbs = [
		{label:'Projects', url:'projects'},
		{label:'Edit project details', url:''}
	];

	useEffect(()=>{
		$(".lastdisable").trigger("focus");
	}, [])
	$(document).ready(function(){
		$(".intendentUse .cw__input").attr({
		"aria-describedby":"user-error",  
		'aria-required':'true'
	});
	$('.requiredSelect .cw__input').attr({
		'aria-required':'true'
	});
})
  
  const skipTmUpload1Ref = useRef(null);
  
  $('.tooltip-container p').on('keydown', function(e){
    if(e.key === Constants.ESCAPE){
      if ($(this).attr('id') === "initialTranslationTooltipFocus") {
        setRefs(initialTranslationTooltipRef);
      }
      else if ($(this).attr('id') === "vendorBidTooltipFocus") {
        setRefs(vendorBidTooltipRef);
      }
      else if ($(this).attr('id') === "bidTooltipFocus") {
        setRefs(bidTooltipRef);
      }
	  else if ($(this).attr('id') === "purchaseOrderTooltipFocus") {
        setRefs(purchaseOrderTooltipRef);
      }
	  else if ($(this).attr('id') === "targetLanguageTooltipFocus") {
        setRefs(targetLanguageTooltipRef);
      }
	  else if ($(this).attr('id') === "projectFollowers1Focus") {
        setRefs(projectFollowers1Ref);
      }
	  else if ($(this).attr('id') === "skipTmUpload1Focus") {
        setRefs(skipTmUpload1Ref);
      }
    }
  });
  useEffect(()=>{
   if (refs.current) {
      refs.current.hideTooltip();
      setRefs({});
    }
  }, [refs]);

const setTabChange=(status)=>{
	if(status){
		let elementsToBeAdded = [];
		if(projectWorkflowsRedux && projectWorkflowsRedux.length > 0){
			projectWorkflowsRedux?.map((workflow) => {
		  workflow.steps.map((step) => {
			step.phases.map((phase) => {
			  if(phase.assigneeType.code === 'customer_user' && phase.assigneeUsers.length !== 0) {
				let userExists = checkIfUserIsFollower(phase.assigneeUsers[0].userId, elementsToBeAdded);
				if(userExists === 0) {
				  let elementRoleTypes = phase.assigneeUsers[0].roleSet.roleTypes.map((roleType) => roleType.displayName);
				  let elementToBeAdded = {
					id: phase.assigneeUsers[0].userId,
					label: phase.assigneeUsers[0].firstName + " " + phase.assigneeUsers[0].lastName,
					resource: {
					  "path" : "",
					  "applicationVersion" : "",
					  "id" : "",
					  "customerUser" : phase.assigneeUsers[0],
					  "reviewLanguages" : "",
					  "projectWorkflowAssignee" : false
					},
					roleSet: {
					  roleTypeList: undefined,
					  roleTypes: phase.assigneeUsers[0].roleSet.roleTypes
					},
					value: elementRoleTypes
				  }
				  elementsToBeAdded.push(elementToBeAdded?.resource?.customerUser);
				}
			  }
			})
		  })
		})
		setProjectWorkFlowReduxTemp(elementsToBeAdded)
		setTabStatus(false)
		}	
	}else{
		let elementsToBeAdded = [];
		if(projectWorkflowsRedux && projectWorkflowsRedux.length > 0){
			projectWorkflowsRedux?.map((workflow) => {
		  workflow.steps.map((step) => {
			step.phases.map((phase) => {
			  if(phase.assigneeType.code === 'customer_user' && phase.assigneeUsers.length !== 0) {
				let userExists = checkIfUserIsFollower(phase.assigneeUsers[0].userId, elementsToBeAdded);
				if(userExists === 0) {
				  let elementRoleTypes = phase.assigneeUsers[0].roleSet.roleTypes.map((roleType) => roleType.displayName);
				  let elementToBeAdded = {
					id: phase.assigneeUsers[0].userId,
					label: phase.assigneeUsers[0].firstName + " " + phase.assigneeUsers[0].lastName,
					resource: {
					  "path" : "",
					  "applicationVersion" : "",
					  "id" : "",
					  "customerUser" : phase.assigneeUsers[0],
					  "reviewLanguages" : "",
					  "projectWorkflowAssignee" : false
					},
					roleSet: {
					  roleTypeList: undefined,
					  roleTypes: phase.assigneeUsers[0].roleSet.roleTypes
					},
					value: elementRoleTypes
				  }
				  elementsToBeAdded.push(elementToBeAdded?.resource?.customerUser);
				}
			  }
			})
		  })
		})
		setProjectWorkFlowReduxTemp(elementsToBeAdded)
		}	
		setTabStatus(true)
	}
}

useEffect(()=>{
	if(projectWorkFlowReduxTemp && projectWorkFlowReduxTemp.length > 0){
		if(projectFollowersRedux?.followersCollection && projectFollowersRedux?.followersCollection?.length > 0){
			let followersCollection=projectFollowersRedux?.followersCollection
			let finalFollowersCollectionData=followersCollection.filter(data=>data.label !=="undefined undefined");
			   finalFollowersCollectionData=finalFollowersCollectionData.map(data=>{
				return {...data?.resource?.customerUser,removable:false}
			   })
			   var dataNew = [...members, ...finalFollowersCollectionData];

			   dataNew = dataNew.map(data => {
				   const foundUser = projectWorkFlowReduxTemp.find(res => res?.userId === data?.userId);
				   if (foundUser) {
					   return { ...data, removable: true };
				   } else {
					   return { ...data, removable: false };
				   }
			   });
			   
			 var filterData=removeDuplicatesByProperty(dataNew,"userId")
			 let projectFollowers=filterData.map(data => {
				if(data?.reviewLanguage &&  data?.reviewLanguage?.length > 0){
				return	{
						applicationVersion: null,
						customerUser: data,
						id: null,
						path: null,
						projectWorkflowAssignee: false,
						reviewLanguages: data?.reviewLanguage !==undefined?data?.reviewLanguage:null,
					}
				}else{
					return	{
						applicationVersion: null,
						customerUser: data,
						id: null,
						path: null,
						projectWorkflowAssignee: false,
						reviewLanguages: data?.reviewLanguage !==undefined?data?.reviewLanguage:null,
						unremovable:false
					}
				}
			})
			dispatchFinalDataToRedux('projectFollowers', projectFollowers)
             setMembers(filterData)
		  }
	}
},[projectWorkFlowReduxTemp])

function removeDuplicatesByProperty(arr, prop) {
    return arr.filter((obj, index, self) =>
        index === self.findIndex((o) => o[prop] === obj[prop])
    );
}
  
	const calculateBidSelectionDeadlineDate = () => {
		if(!projectData.bidDueDate || !projectData.deliveryDueDate) {
			return null;
		}
		var bidDue = new Date(dateUtil.convertToLocalDateTimestamp(projectData?.bidDueDate))
		bidDue.setHours(bidDueTime);
		var bidDueTimestamp = timeStamp(bidDue, userTimeZone).utcTimestamp;
		var deliveryDue = new Date(dateUtil.convertToLocalDateTimestamp(projectData?.deliveryDueDate))
		deliveryDue.setHours(deliveryDueTime);
		var deliveryDueTimestamp = timeStamp(deliveryDue, userTimeZone).utcTimestamp;
		var differenceInHours = Math.round((deliveryDueTimestamp - bidDueTimestamp) / (60 * 60 * 1000));
		differenceInHours = differenceInHours * .25;
		
		var hoursToAddToBidDueDate = Math.abs(differenceInHours);
		
		if(hoursToAddToBidDueDate < 2) {
			hoursToAddToBidDueDate = 2;
		}

		let bidSelectionDate = bidDue;
	    bidSelectionDate.setHours(bidDue.getHours()+hoursToAddToBidDueDate);
		return bidSelectionDate;
	}
  
  const onBidDueDaySelect=(event)=>{

	var newBidDueDate = moment(event).set({
		'hour': 0,
		'minute': 0,
		'second': 0,
		'millisecond': 0,
	  });
	setMinDueDate(newBidDueDate.valueOf())
	// newBidDueDate = utcDateTimeWithTimeZone(event)		
	var newBidDueDateHour = bidDueTime;
	if(newBidDueDateHour) {
		// if the bid due hour is specified, set it
		// otherwise, the hour will get adjusted by the "onDateChanged" call to the first available hour for this day
		newBidDueDate.add(parseInt(newBidDueDateHour),"hours");				
	}
	// update model
	dispatchFinalDataToRedux('bidDueDate', newBidDueDate)
	dispatchFinalDataToRedux('bidDueDateChanged', true)
	bumpDeliveryDueDateIfNecessary(newBidDueDate);	
	if(!newBidDueDateHour) {
		// if the bid due date hour is not set, and 5PM is an available option for the selected bid due date
		// default to 5PM
		var fivePM = bidDueDateHoursList.find(data=>data.value ===17);
		if(!fivePM.isDisabled) {
			setBidDueTime(17)
		}
	}

	toggleCal(false)
	$('.calFirstFocus').trigger('focus')
	$('#calFirstFocus').removeClass('calFirstFocus')
}

const bumpDeliveryDueDateIfNecessary =()=>{
	const isDeliveryDateStillValid = deliveryDueDateHoursList.filter(data=>data.value !==-1)?.some(option => !option.isDisabled );
	if(!isDeliveryDateStillValid) {
		var bidDue = new Date(dateUtil.convertToLocalDateTimestamp(projectData?.bidDueDate))
		bidDue.setHours(17);
		bidDue.setDate(bidDue.getDate()+1);
		dispatchFinalDataToRedux('deliveryDueDate', timeStamp(bidDue, userTimeZone))
		dispatchFinalDataToRedux('deliveryDueDateChanged', true)
		const newDeliveryDueDateHourList = deliveryDueDateHoursList.map((obj,index)=>{
			if(index === 0){ obj.isDisabled = true; }
			else{ obj.isDisabled = false; }
			return obj;
		})
		setDeliveryDueDateHourList(newDeliveryDueDateHourList)
		setDeliveryDueTime(17);
		onDeliveryDueDaySelect(timeStamp(bidDue, userTimeZone));
	}
	setBumpDeliveryDueDate(false);
}
const isBiddingEnabled = () => {
	return ((projectData?.projectVendorType !== "INTERNAL") && (projectData?.projectVendorType !== "MACHINE_TRANSLATION") && (projectData?.projectVendorType !== "EXTERNAL_BIDLESS"));
}
 const isInternalTranlator = ()=> {
	return (projectData === "INTERNAL");
  }
  const isExternalBidless =() =>{
	return (projectData === "EXTERNAL_BIDLESS");
  }
 const isMachineTranslation = ()=> {
	return (projectData === "MACHINE_TRANSLATION");
  }

const onDeliveryDueDaySelect = (event)=> {
	var newDeliveryDueDate = new Date(event.utcTimestamp ? event.utcTimestamp : event);
	newDeliveryDueDate.setHours(event.utcTimestamp ? 17 : deliveryDueTime);
	dispatchFinalDataToRedux('deliveryDueDate', timeStamp(newDeliveryDueDate, userTimeZone))
	dispatchFinalDataToRedux('deliveryDueDateChanged', true)
	setInvokeDateChanged(true);
	toggleIntialCalFlag(false);
		
	if(!allowRushProject()) {
		var now = new Date();
		now.setHours(now.getHours()+48);
		const isSameDay = now.getDay() === newDeliveryDueDate.getDay();
		if(isSameDay) {
			setNeedItSooner(true)  
		}
	}
	$('.calFirstFocus').trigger('focus')
	$('#calFirstFocus').removeClass('calFirstFocus')
}


const onDeliveryDueDateHourChange =(e)=> {
	if(projectData.deliveryDueDate) {
		var deliveryDueDate = moment(getDateTimestamp(projectData.deliveryDueDate)).tz(userTimeZone);
		var hour =parseInt(e?.value);
		deliveryDueDate.set({
			'hour': hour,
			'minute': 0,
			'second': 0,
			'millisecond': 0,
		  })
		setDeliveryDueTime(hour)
		// update model
		dispatchFinalDataToRedux('deliveryDueDate', deliveryDueDate)
		dispatchFinalDataToRedux('deliveryDueDateChanged', true)	
		onDateChanged(projectData?.bidDueDate,deliveryDueDate)	
	}
}
const onBidDueDateHourChange =(e)=> {
	if(projectData?.bidDueDate) {
		var bidDueDate = moment(getDateTimestamp(projectData?.bidDueDate)).tz(userTimeZone);
		var hour = parseInt(e.value);
		bidDueDate.set({
			'hour': hour,
			'minute': 0,
			'second': 0,
			'millisecond': 0,
		  })
		setBidDueTime(hour)
		// update model
		dispatchFinalDataToRedux('bidDueDate', bidDueDate)
		dispatchFinalDataToRedux('bidDueDateChanged', true)
		bumpDeliveryDueDateIfNecessary(bidDueDate);	
	}
	}


	const isLessThanMinimumBidDueDate = (bidDueDate, alwaysAllowSameDay, rushProjectAllowed) => {
		var date = bidDueDate;
		var minBidDueDate = new Date();
		if (!rushProjectAllowed) {
			alwaysAllowSameDay = false;
		}
		if (alwaysAllowSameDay) {
			date.setHours(minBidDueDate.getHours());
			date.setMinutes(minBidDueDate.getMinutes());
			date.setSeconds(minBidDueDate.getSeconds());
			date.setMilliseconds(minBidDueDate.getMilliseconds());
		}
		roundToFullHour(minBidDueDate);
		if (allowRushProject) {
			minBidDueDate.setHours(minBidDueDate.getHours() + MINIMUM_RUSH_BID_DUE_DATE_DELAY);
		} else {
			minBidDueDate.setHours(minBidDueDate.getHours() + MINIMUM_BID_DUE_DATE_DELAY);
		}
		var isDateAcceptable = false;

		if (alwaysAllowSameDay && isSameDay(date, minBidDueDate)) {
			isDateAcceptable = true;
		} else {
			isDateAcceptable = date.getTime() >= minBidDueDate.getTime();
		}

		return !isDateAcceptable;
	}

	const isDeliveryDueDateAfterBidDueDate = (deliveryDueDate, bidDueDate, rushProjectAllowed) => {
		if (bidDueDate == null) {
			return true;
		}
		let deliveryDue = timeStamp(deliveryDueDate, userTimeZone);
		if (rushProjectAllowed) {
			return (deliveryDue.utcTimestamp - bidDueDate) >= 14400000; // at least 4 hours after bid due date  
		} else {
			return (deliveryDue.utcTimestamp - bidDueDate) >= 86400000; // at least 24 hours after bid due date
		}
	}

	const getDateOrTimestamp = (date) => {
		if (date) {
			if (date?.utcTimestamp) {
				return date?.utcTimestamp;
			} else {
				return date;
			}
		}
	}

const showBidSelectWarningIfNecessary =()=> {
	if(projectData?.bidSelectDeadlineDate && (!projectData.status || !projectData?.status?.bidSelected)) {
		var newBidSelectDeadline = moment(projectData.bidSelectDeadlineDate).tz(userTimeZone);
		// var bidSelectContainer = jQuery(this.el).find(".bidSelectDeadlineContainer");
		var bidSelectContainer =null;
		var bidSelectDay = newBidSelectDeadline?.day();
		var bidSelectHour = newBidSelectDeadline?.hours();
		var fallsOnWeekend = bidSelectDay < 1 || bidSelectDay > 5; // falls on weekend
		var outsideCoreHours = bidSelectHour < 9 || bidSelectHour > 17; // outside of core business hours 9-5pm
	}
}


	const isLessThanMinimumDeliveryDueDate = (deliveryDueDate, alwaysAllowSameDay, rushProjectAllowed) => {
		var date = deliveryDueDate;
		var minDeliveryDueDate = new Date();
		if (!rushProjectAllowed) {
			alwaysAllowSameDay = false;
		}
		if (alwaysAllowSameDay) {
			date.setHours(minDeliveryDueDate.getHours());
			date.setMinutes(minDeliveryDueDate.getMinutes());
			date.setSeconds(minDeliveryDueDate.getSeconds());
			date.setMilliseconds(minDeliveryDueDate.getMilliseconds());
		}
		roundToFullHour(minDeliveryDueDate);
		if (allowRushProject) {
			minDeliveryDueDate.setHours(minDeliveryDueDate.getHours() + 6);
		} else {
			minDeliveryDueDate.setHours(minDeliveryDueDate.getHours() + 48);
		}
		var isDateAcceptable = false;

		if (alwaysAllowSameDay && isSameDay(date, minDeliveryDueDate)) {
			isDateAcceptable = true;
		} else {
			isDateAcceptable = date.getTime() >= minDeliveryDueDate.getTime();
		}

		return !isDateAcceptable;
	}

	const isValidBidDueDate = (bidDueDate, alwaysAllowSameDay, rushProjectAllowed) => {
		return !isLessThanMinimumBidDueDate(bidDueDate, alwaysAllowSameDay, rushProjectAllowed);
	}

	const isValidDeliveryDueDate = (deliveryDueDate, bidDueDate, alwaysAllowSameDay, rushProjectAllowed) => {
		return isDeliveryDueDateAfterBidDueDate(deliveryDueDate, bidDueDate, rushProjectAllowed) &&
        !isLessThanMinimumDeliveryDueDate(deliveryDueDate, alwaysAllowSameDay, rushProjectAllowed);
	}

	const getValidBidDueHourForDate = (bidDueDate, rushProjectAllowed) => {
		var validHours = [];
		var bidDue = new Date(dateUtil.convertToLocalDateTimestamp(bidDueDate))
		for (var i = 0; i < 24; i++) {
			bidDue.setHours(i);
			if (isValidBidDueDate(bidDue, false, rushProjectAllowed)) {
				validHours.push(i);
			}
		}
		return validHours;
	}

	const getValidDeliveryDueHourForDate = (deliveryDueDate, bidDueDate, rushProjectAllowed) => {
		var validHours = [];
		var formattedDeliveryDue = new Date(dateUtil.convertToLocalDateTimestamp(deliveryDueDate))
		for (var i = 0; i < 24; i++) {
			formattedDeliveryDue.setHours(i);
			if (isValidDeliveryDueDate(formattedDeliveryDue, bidDueDate, false, rushProjectAllowed)) {
				validHours.push(i);
			}
		}
		return validHours;
	}

	const updateValidBidDueDateHours = (updatedBidDueDate) => {
		if(!updatedBidDueDate) {
			return;
		}
		let validHours = getValidBidDueHourForDate(updatedBidDueDate?.utcTimestamp, allowRushProject());
		let hoursList =bidDueDateHoursList.map(option => {
			const hour = parseInt(option.value, 10);
			if (validHours.includes(hour)) {
				return {...option,isDisabled:false}
			} else {
				return {...option,isDisabled:true}
			}
		});
		setBidDueDateHourList(hoursList)
	}

	const updateValidDeliveryDueDateHours = (updatedBidDueDate) => {
		if(!projectData.deliveryDueDate || !updatedBidDueDate) {
			return;
		}
		var validHours = getValidDeliveryDueHourForDate(projectData.deliveryDueDate?.utcTimestamp, updatedBidDueDate?.utcTimestamp, allowRushProject());
		let hoursList =deliveryDueDateHoursList.map(option => {
			const hour = parseInt(option.value, 10);
			if (validHours.includes(hour)) {
				return {...option,isDisabled:false}
			} else {
				return {...option,isDisabled:true}
			}
		});
		setDeliveryDueDateHourList(hoursList);
	}

	const onDateChanged = (updatedBidDueDate) => {
		updateValidBidDueDateHours(updatedBidDueDate);
		updateValidDeliveryDueDateHours(updatedBidDueDate);

		if(isBiddingEnabled() && (!projectData?.status || !projectStatus?.bidSelected)) {
			setCalculateBidSelectionDeadline(true);
		}
	}

	const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? 'gray' : 'black', // Change color of disabled options
      cursor: state.isDisabled ? 'not-allowed' : 'default', // Change cursor style for disabled options
      // Add more custom styling properties as needed
    }),
  };

	const allowRushProject =()=> {
		return custBootstrapDataRedux?.features?.RUSH_PROJECT;
	}

	return (
		<>
			<div >
				<div id="container" className="dashboard-wrapper">
					<Header ref={scrollRef} />
					<LeftNavbar />
					<section className="dashboard-content" ref={scrollRef}>
						<div id="content" className="dashboard-wrap campaign-section" >
							<Breadcrumb crumbs={crumbs} />
							<div className="white-bg campaign-page">
								<div className="campaign-edit-section project-edit-section">
									<div className="name-card-section">
										<div className="name-card-section-left">
											<div className="campaign-name">
												<button type="button" className="back-btn" aria-label="back" onClick={backToProject} onKeyDown={(e)=>handleBackToProject(e)}>
													<svg onClick={backToProject} xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
														<path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#4D4D4D"></path>
													</svg>
												</button>
												<h3>Edit Project: {projectData?.projectName}</h3>
											</div>
											<p>Make and save any project changes.</p>
										</div>
									</div>
									<div className="listing-tab-block flex">
										<ul className="listing-tab-link flex" role="tablist">
												<li role="none"><button type="button" onClick={() => setTabChange()} role="tab"
												   aria-label={tabStatus ? "Current tab, Details & Followers" : "Details & Followers"}
												   aria-selected={tabStatus ?  "true" : "false"}
												   className={tabStatus ? "active" : ""}>Details & Followers</button> 
												  </li>
												<li role="none">
													<button type="button" onClick={() => setTabStatus(false)} role="tab"
													 aria-label={tabStatus ?  "Review Workflow" : "Current tab, Review Workflow"}
													 aria-selected={tabStatus ?  "false" : "true"} className={tabStatus ? "" : "active"}>Review Workflow</button></li>
										</ul>
									</div>
									{tabStatus ?
										<div className="create-campaign-content flex ">
											<div className="project-information left-width">
												<div className="flex wrap-dropdown">
													<div className="global-dropdown-block flex-center w-d100">
														<label htmlFor="pname">Project Name</label>
														{projectStatusEditableField?.indexOf("name") !== -1 ?
															<input id="pname" name="name" type="text" aria-required="true" value={projectData.name} 
																onChange={fieldChange} className="form-control-sm" placeholder="Project Name" 
																maxLength={MAX_CHARS}
																aria-label="Project Name"
																/>
															: projectData.name}
														<div className="left">
														<span style={{fontSize:"smaller"}}>
															{MAX_CHARS - projectData?.name?.length} characters remaining
															</span>
														</div>
													</div>
												</div>
												<div className="flex wrap-dropdown">
													<div className="global-dropdown-block flex-center w-d100">
														<label  htmlFor="project-desc">Project Description <span>Optional</span></label>
														{projectStatusEditableField?.indexOf("description") !== -1 ?
															<textarea name="description" value={projectData.description ? projectData.description : ""} onChange={event => fieldChange(event)} className="textarea" placeholder="5000 character limit" 
															id='project-desc' aria-label="Project Description Optional"></textarea>
															: projectData.description}
													</div>
												</div>

												<div className="flex wrap-dropdown">
													<div className="global-dropdown-block intendentUse flex-center">
														<label>Intended Use  {invalidIntendedUse && projectData?.intendedUse === "" ? <span id="user-error" className="textDanger">Invalid Intended use. </span> : Constants.BLANK}</label>
														<div className="global-dropdown-select">
															{projectStatusEditableField?.indexOf("intendedUse") !== -1 ?
																<Select classNamePrefix='cw' className='global-dropdown-select file_upload'
																	value={intendendUseTaskData?.filter(function (option) {
																		return option?.value === projectData?.intendedUse?.name;
																	})}
																	placeholder={"---Select One---"} onChange={event => handleChange(event, 'intendedUse')}
																	aria-label="Intended Use" name='intendedUse' options={intendendUseTaskData} />
																: projectData?.intendedUse?.name}
														</div>
													</div>
													<div className="global-dropdown-block flex-center">
														<label>Priority <span>Optional</span></label>
														{projectStatusEditableField?.indexOf("priority") !== -1 ?

															<Select classNamePrefix='cw' className='global-dropdown-select file_upload'
																value={priorities.filter(function (option) {
																	return option.value === projectData?.priority;
																})}
																isClearable={true} onChange={event => handleChange(event, 'priority')} aria-label="Priority Optional" 
																id='priority-id' name='priority' options={priorities} />
															: projectData?.priority}
													</div>
												</div>

												<div className="flex wrap-dropdown">
													<div className="global-dropdown-block flex-center">
														<label>Campaign <span>Optional</span></label>
														{pastCampaignStatus ? <p className='textDanger'>{Constants.PAST_CAMPAIGN_MSG}</p> : null}
														{workspaceCampaign?.length > 0 && projectStatusEditableField?.indexOf("campaign") !==-1 ?
															<Select classNamePrefix='cw' className='global-dropdown-select ' options={workspaceCampaign} onChange={event => setPastCampaign(event)}
																value={workspaceCampaign?.filter(function (option) {
																	return option?.value === projectData?.workspace?.id;
																})}
																isClearable={true} name='workspace' id='campaign-id'
																aria-label="Campaign Optional" /> 
															: projectData?.workspace?.name}
													</div>
													<div className="global-dropdown-block tags flex-center">
														<label className="tagsLabel">Tags <span>Optional</span></label>

														<Select classNamePrefix='cw'
															className='global-dropdown-select'
															value={tagsDropdown.filter(function (option) {
																return option?.value === projectData?.tags;
															})} id='tags-id'
															onChange={(event) => handleTagsChange(event)}
															isMulti closeMenuOnSelect={true} options={tagsDropdown}
															onKeyDown={(event) => handleTagsChange(event)} aria-label="Tags Optional"/>

														<div className="multiselect-output tagsBox flex">

															{tagsData && tagsData.length > 0 &&
																tagsData.map((tags, index) => (
																	<button type="button" key={index} onClick={(e) => clearTags(e, tags)}
																	aria-label={"Remove " + tags} onKeyDown={(e)=>clearTagsonKeydown(e, tags)}>
																		<strong>{tags}</strong>
																		{CrossIcon}
																	</button>
																)
																)
															}
														</div>
													</div>
												</div>
												<div className="flex wrap-dropdown">
													<div className="global-dropdown-block flex-center firstCal">
														{isBiddingEnabled() && !isInternalTranlator() && !isExternalBidless() && !isMachineTranslation() && projectData.bidDueDate !== "" ?
															<div className="w-d100">
																<div className="tooltip-container flex-align">
																	<label htmlFor="calFirstFocus">Vendors must submit quotes by </label>
																	<p tabIndex={0} data-events={['focus']} data-eventsoff={['blur']}
																		data-padding="10px 10px 10px 10px" data-place="right"
																		data-tip data-for="vendorBidTooltip"
																		aria-label="Tooltip" id="vendorBidTooltipFocus" className="m-0">
																		{FollowerTooltipIcon}
																		<span className="font-zero">
																          <strong>Vendor quote Submission Deadline</strong>
																	      {Constants.VENDOR_BID_DEADLINE_TOOLIP}
																       </span>
																	</p>
																	<ReactTooltip className="tooltip" id="vendorBidTooltip" ref={vendorBidTooltipRef}>
																		<div className="mar-bot6">
																          <strong>Vendor quote Submission Deadline</strong>
															         	</div>
																       {Constants.VENDOR_BID_DEADLINE_TOOLIP}
																	</ReactTooltip>
																</div>

																{projectStatusEditableField.indexOf("bidDueDate") !== -1 ?
																	<div className="flex-center w-d100">
																		<div className="global-dropdown-select lg-dropdown">

																			<button type="button"
																				onClick={(e) => {
																					showCalendarDueDate(e);
																				}}
																				onKeyDown={(e) => handleEscFocus(e)}
																				ref={refToggle}
																				tabIndex={0}
                                                                            	className="drop-down-btn gb-dropBtn"
																				id='calFirstFocus'
																				aria-expanded={toggle ? 'true':'false'}
																				aria-label={projectDeliveryDueDate !== '' ? `Vendors must submit quotes by ${dateFormatAccToTimeZone(projectDeliveryDueDate, custDateFormat, userTimeZone)} selected`  : projectData?.bidDueDate ?
																		 		`Vendors must submit quotes by ${dateFormatAccToTimeZone(projectData?.bidDueDate, custDateFormat, userTimeZone)}` : ""}
																				>
																				<span>{dateFormatAccToTimeZone(projectData?.bidDueDate, custDateFormat, userTimeZone)}</span>
																				<svg
																					aria-hidden="true"
																					className="calender-icon"
																					xmlns="http://www.w3.org/2000/svg"
																					viewBox="0 0 14 14"
																					fill="none"
																				>
																					<path
																						d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
																						fill="#3564EB"
																					/>
																				</svg>

																			</button>

																		</div>
																		{toggle ? (<div ref={refCalendar}
																			onKeyDown={(e) => {
																				closeCalendar(e);
																			}}
																			>
																			<DatePickerCalendar
																				value={new Date(getDateTimestamp(projectData?.bidDueDate))}
																				className="dashCalendarDeadLine"
																				minDate={new Date()}
																				selectDate={onBidDueDaySelect}
																				/>
																		</div>) : (
																			""
																		)}
																		<Select classNamePrefix='cw' className="global-dropdown-select small-dropdown-select"
																			value={TIME_LIST_DATA.filter(function (option) {
																				return option?.value === bidDueTime;

																			})}
																			aria-label="What Time?"
																			onChange={event => onBidDueDateHourChange(event)}
																			options={bidDueDateHoursList}
																			styles={customStyles}
																		/>
																	</div> : <span>{dateFormatAccToTimeZone(projectData?.bidDueDate, custDateFormat, userTimeZone)}</span>
																}
															</div> : null}

													</div>
													<div className="global-dropdown-block flex-center caltopset">
														<div className="tooltip-container flex-align">
															<label htmlFor="calSecondFocus">I need initial translation by </label>
															<p tabIndex={0} data-events={['focus']} data-eventsoff={['blur']} data-padding="10px 10px 10px 10px" data-place="right"
															 data-tip data-for="initialTranslationTooltip" aria-label="Tooltip" id="initialTranslationTooltipFocus" className="m-0">
																{FollowerTooltipIcon}
																<span className="font-zero">
																    <strong>Initial Translation Deadline</strong>
																	{Constants.DEADLINE_VENDOR}
																</span>
															</p>
															<ReactTooltip className="tooltip" id="initialTranslationTooltip" role="tooltip" ref={initialTranslationTooltipRef}>
																<div className="mar-bot6">
																  <strong>Initial Translation Deadline</strong>
																</div>
																{Constants.DEADLINE_VENDOR}
															</ReactTooltip>
														</div>
														{projectStatusEditableField.indexOf("deliveryDueDate") !== -1 ?
															<div className="flex-center w-d100">
																<div className="global-dropdown-select lg-dropdown" >
																	<button onClick={(e) => {showCalendarDeliveryDate(e);}} onKeyDown={(e) => handleEscFocus2(e)} ref={refToggle2}
																		tabIndex={0} id='calSecondFocus' aria-expanded={toggleIntialCal ? 'true':'false'}

																		aria-label={projectData?.deliveryDueDate !== '' ? `I need initial translation by ${dateFormatAccToTimeZone(projectData?.deliveryDueDate, custDateFormat, userTimeZone)} selected`  : minDueDate ?
																		 `I need initial translation by ${dateFormatAccToTimeZone(minDueDate, custDateFormat, userTimeZone)} selected` : ""}
																		type="button" className="drop-down-btn gb-dropBtn">
																		<span>{projectData?.deliveryDueDate ? dateFormatAccToTimeZone(projectData?.deliveryDueDate, custDateFormat, userTimeZone) : minDueDate ? dateFormatAccToTimeZone(minDueDate, custDateFormat, userTimeZone)  : ""}</span>
                														<span className="font-zero">{projectData.deliveryDueDate ? dateFormatAccToTimeZone(projectData?.deliveryDueDate,custDateFormat, userTimeZone) : minDueDate ? dateFormatAccToTimeZone(minDueDate,custDateFormat, userTimeZone): "delivery due Date"}</span>
																		<svg aria-hidden="true" className="calender-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
																			<path d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z" fill="#3564EB" />
																		</svg>
																	</button>
																</div>
																{toggleIntialCal ? (<div ref={refCalendar2}
																	onKeyDown={(e) => {closeCalendar2(e);}}>

																	<DatePickerCalendar className="dashCalendarMachine2"
																						value={new Date(getDateTimestamp(projectData?.deliveryDueDate))}
																						minDate={minDueDate ? new Date(minDueDate): new Date()}
																						selectDate={onDeliveryDueDaySelect}/>
																</div>) : ("")}

																<Select classNamePrefix='cw' className="global-dropdown-select small-dropdown-select"
																	value={deliveryDueDateHoursList.filter(function (option) {
																		return option?.value === deliveryDueTime;
																	})} aria-label="What Time?" onChange={event => onDeliveryDueDateHourChange(event)} options={deliveryDueDateHoursList} styles={customStyles}
																	isOptionDisabled={(option) => option.isDisabled} />
															</div> :

															<span>{projectData?.deliveryDueDate ? dateFormatAccToTimeZone(projectData.deliveryDueDate, custDateFormat, userTimeZone) : "Please select delivery due date"}</span>
														}
													</div>
												</div>
												<div className="flex wrap-dropdown">
													{isBiddingEnabled() &&  projectData?.bidSelectDeadlineDate && projectData?.projectVendorType !== "EXTERNAL_BIDLESS" && projectData?.projectVendorType !== "INTERNAL" ?
														<div className="global-dropdown-block flex-center">
															<div className="tooltip-container flex-align">
																<h6>You will have to select the quote by</h6>
																<p tabIndex={0} data-events={['focus']} data-eventsoff={['blur']} data-padding="10px 10px 10px 10px"
																	data-place="right" data-tip={Constants.BID_SELECTION_DEADLINE_TOOLTIP} data-for="bid-selection-deadline-tooltip"
																	aria-label="Tooltip" id="bidTooltipFocus" className="m-0">
																	{FollowerTooltipIcon}
																	<span className="font-zero">{Constants.BID_SELECTION_DEADLINE_TOOLTIP}</span>
																</p>
																<ReactTooltip className="tooltip" id="bid-selection-deadline-tooltip" role="tooltip" ref={bidTooltipRef} />
															</div>
															{bidSelectDeadlineDate !== "" ? <span role="button" aria-label="error" className="alert-icon" tabIndex="0">
																{bidSelectDeadlineDate?.dateWithTime ? bidSelectDeadlineDate?.dateWithTime : dateUtil.format(bidSelectDeadlineDate, custDateFormat + Constants.SINGLE_WHITESPACE + Constants.TIME_FORMAT, userTimeZone)}
															</span> :
																projectData?.bidSelectDeadlineDate !== null ?
																	(<span className="alert-icon">
																		{projectData?.bidSelectDeadlineDate?.dateWithTime ? projectData?.bidSelectDeadlineDate?.dateWithTime : dateUtil.format(projectData?.bidSelectDeadlineDate, custDateFormat + Constants.SINGLE_WHITESPACE + Constants.TIME_FORMAT, userTimeZone)}
																	</span>) :
																	(<span>To be determined based on your bid submission and initial translation deadline</span>)}
														</div>
														: ""}
															{projectStatusEditableField?.indexOf("poNumber") !== -1 ?
													<PurchaseOrder purchaseOrdersEnabled={accountPermission?.features?.PURCHASE_ORDERS} projectStatus={projectStatus} customerPurchaseOrder={customerPurchaseOrder} purchaseOrderRequired={purchaseOrderRequired} setCustomerPO={setCustomerPO} purchaseOrderTooltipRef={purchaseOrderTooltipRef} />
													:""}
														
												</div>
												<div className="flex wrap-dropdown">
													<div className="global-dropdown-block flex-center">
														<label>Department</label>
														<div className="global-dropdown-select">
															<Select classNamePrefix='cw'
																value={departments.filter(function (option) {
																	return option.value === projectData?.userGroup?.id;
																})}
																options={departments}
																onChange={event => setDepartment(event)}
																aria-label="Department"
															/>

														</div>
													</div>
													<div className="global-dropdown-block flex-center">
														<label>Project Owner</label>
														<div className="global-dropdown-select">
															<Select classNamePrefix='cw' className="requiredSelect"
																value={projectOwner?.filter(function (option) {
																	return option.value === projectData?.owner?.userId;
																})}
																options={projectOwner}
																isLoading={ownerLoading}
																onChange={setOwner}
																aria-label="Project Owner"
															/>

														</div>
													</div>
												</div>
												<div className="flex wrap-dropdown">
													<div className="global-dropdown-block flex-center">
														<label>What is your source language ?</label>
														{projectStatusEditableField?.indexOf("sourceLanguages") !== -1 ?
															<><div className="global-dropdown-select">
																<Select classNamePrefix='cw'
																value={selectedSourceLanguage}
																options={sourceLanguage}
																onChange={(event) => handleSourceLanguageChange(event)}
																aria-label='What is your source language ? '
															/>
															</div>
																<div className="multiselect-output flex">
																	{selectedSourceLanguage && <button type="button" onClick={(e) => clearSourceLanguage(e)} onKeyDown={(e) => clearSourceLanguageOnKeydown(e)}>
																		<strong>{selectedSourceLanguage?.display}</strong>
																		<svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
																			<path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
																		</svg>
																	</button>}

																</div></> :
															<div className="multiselect-output flex">
																{languageDetail && <button type="button" >
																	<strong>{languageDetail?.sourceLanguage?.display}</strong>
																</button>}

															</div>}
													</div>
													<div className="global-dropdown-block flex-center">
													<label>What languages do you want to translate to ?    </label>
														{projectStatusEditableField?.indexOf("targetLanguages") !== -1 ?
															<>
																<div className="global-dropdown-select">
																	<Select classNamePrefix='cw'
																options={targetLanguage}
																onChange={(event) => handleTargetLanguageChange(event)}
																aria-label='What languages do you want to translate to ? '
															/>

																</div>
																<div className="multiselect-output flex">
																	{selectedTargetLanguageList &&
																		selectedTargetLanguageList.map((targetLanguage, index) => (
																			<button type="button"
																			 aria-label={'remove ' + targetLanguage.display}
																			 key={index} onClick={(e) => clearTargetLanguage(targetLanguage)} onKeyDown={(e) => clearTargetLanguageOnKeydown(targetLanguage)}>
																				<strong>{targetLanguage?.display}</strong>
																				<svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
																					<path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
																				</svg>
																			</button>
																		)
																		)
																	}
																</div></> :
															<div className="multiselect-output flex">
																{selectedTargetLanguageList &&
																	selectedTargetLanguageList.map((targetLanguage, index) => (
																		<button type="button" key={index} >
																			<strong>{targetLanguage?.display}</strong>
																		</button>
																	)
																	)
																}
															</div>
														}
													</div>
												</div>
												{projectStatusEditableField?.indexOf("targetLanguages") === -1 && !projectStatus?.translationProcessFinished ? <div className="flex wrap-dropdown">
													<div className="global-dropdown-block flex-center w-d100">
														<div><Link aria-expanded={languageStatus ? 'true':'false'} onClick={() => setLanguageStatus(!languageStatus)} >Looking to add or remove a target language?</Link></div>
														{languageStatus ? <p>
															You can create a<Link to={"/project/" + param.id + "?value=changeOrder"}> Change Order</Link> to alter the project requirements, such as adding target languages after the project has been assigned to a specific vendor and translation is underway.
														</p> : Constants.BLANK}
													</div>
												</div> : Constants.BLANK}

												<ConditionalBlock condition={custBootstrapDataRedux?.features?.ALTER_TM_UPLOAD_REQUIREMENT && custBootstrapDataRedux?.permissions?.SKIP_PROJECT_TM_UPLOAD}>
													<div className="flex wrap-dropdown">
														<div className="global-dropdown-block flex-center caltopset">
															<div className="tooltip-container align-flex">
																<label>Translation Memory Upload</label>
																<p tabindex={0} data-events={['focus']} data-eventsoff={['blur']} data-padding="10px 10px 10px 10px" data-place="right"
																	data-tip={Constants.SKIP_TRANSLATION_MEMORY_UPLOAD_TOOLTIP} data-for="skipTmUpload" aria-label="Tooltip" id="skipTmUpload1Focus" className="m-0">
																	{FollowerTooltipIcon}
																	<div className="font-zero">
																		<strong>Skip Translation Memory Upload</strong>
																	{Constants.SKIP_TRANSLATION_MEMORY_UPLOAD_TOOLTIP}
																	</div>
																</p>
																<ReactTooltip className="tooltip" id="skipTmUpload" role="tooltip" ref={skipTmUpload1Ref} >
																	<div className="mar-bot6">
																		<strong>Skip Translation Memory Upload</strong>
																	</div>
																	{Constants.SKIP_TRANSLATION_MEMORY_UPLOAD_TOOLTIP}
																</ReactTooltip>
															</div>
														</div>
														<div className="form-check small-checkbox mar-left-20">
															<input className="form-check-input" type="checkbox" name='skipTmUploadCheckbox' id='skipTmUploadCheckbox' checked={projectData.skipTmUpload} onChange={(e) => dispatchFinalDataToRedux('skipTmUpload', e.target.checked)} />
															<label className="form-check-label" htmlFor="skipTmUploadCheckbox">
																Allow vendor to close this project without uploading Translation Memory
															</label>
														</div>
													</div>
												</ConditionalBlock>

												<div className="flex wrap-dropdown">
													<div className="global-dropdown-block flex-center w-d100">
														<label htmlFor="notes-id">Notes and Instructions For Vendors <span>Optional</span></label>
												{projectStatusEditableField?.indexOf("notes")  !== -1?

														<textarea value={projectData?.notes} name="notes" onChange={event => fieldChange(event)} className="textarea" placeholder="2500 character limit" 
														aria-label="Notes and Instructions For Vendors Optional"
														id='notes-id'
														></textarea>
														:projectData?.notes}
													</div>
												</div>
											</div>

											<div className="project-information create-project-information">
												<div className="campaign-member-heading">
													<div className="left">
														<div className="tooltip-container align-flex">
															<h6>Project Followers</h6>
															<p tabIndex={0} data-events={['focus']} data-eventsoff={['blur']} data-padding="10px 10px 10px 10px" data-place="right"
																data-tip={Constants.PROJECT_FOLLLOWERS} data-for="projectFollowers1" aria-label="Tooltip" id="projectFollowers1Focus" className="m-0">
																<svg className="svg-tooltip-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
																	<path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
																</svg>
																<div className="font-zero">
																   {Constants.PROJECT_FOLLLOWERS}
																</div>
															</p>
															<ReactTooltip className="tooltip" id="projectFollowers1" role="tooltip" ref={projectFollowers1Ref} />
														</div>
														<small>Who should receive notifications about this project?</small>
													</div>
													{projectFollowers && projectFollowers?.length > 0?
													<div className="text-with-add flex-center">
														<span></span>
														<button type="button" className="add-another" onClick={displayModalSelectWorkflow}
														onKeyDown={(e)=>displayModalonKeydown(e)}>Add Another</button>
													</div>:Constants.BLANK}
												</div>
												<div className="campaign-member-content">
													<ul className="campaign-member-list">

														{members && members?.length > 0
															&& members.sort((a) => {
																if (a?.userId === projectData?.owner?.userId) {
																	return -1
																} else {
																	return 1
																}
															}).map((value, index) => {
																return (
																	<li key={index}>
																		<div className="list-item flex-center">
																			<span type="button" className="left-details-text" >{value?.firstName + " " + value?.lastName} {projectData?.owner?.userId === value?.userId ? "(Owner)" : ""}  {value?.roleSet?.displayName}</span>
																			{ !(projectData?.owner?.userId === value?.userId) && (!value?.removable)    ? <button type="button" className="remove-btn" onClick={() => { removeFollower(value.userId) }}>
																				<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
																					<path d="M9.34922 4.40039H12.6492C12.6492 3.96278 12.4754 3.5431 12.1659 3.23366C11.8565 2.92423 11.4368 2.75039 10.9992 2.75039C10.5616 2.75039 10.1419 2.92423 9.83249 3.23366C9.52306 3.5431 9.34922 3.96278 9.34922 4.40039ZM8.24922 4.40039C8.24922 3.67105 8.53895 2.97157 9.05467 2.45585C9.5704 1.94012 10.2699 1.65039 10.9992 1.65039C11.7286 1.65039 12.428 1.94012 12.9438 2.45585C13.4595 2.97157 13.7492 3.67105 13.7492 4.40039H19.2492C19.3951 4.40039 19.535 4.45834 19.6381 4.56148C19.7413 4.66463 19.7992 4.80452 19.7992 4.95039C19.7992 5.09626 19.7413 5.23615 19.6381 5.3393C19.535 5.44244 19.3951 5.50039 19.2492 5.50039H18.0898L16.7764 16.8788C16.6836 17.6831 16.2983 18.4252 15.6939 18.9639C15.0894 19.5026 14.3081 19.8003 13.4984 19.8004H8.50002C7.69037 19.8003 6.90899 19.5026 6.30457 18.9639C5.70015 18.4252 5.31486 17.6831 5.22202 16.8788L3.90862 5.50039H2.74922C2.60335 5.50039 2.46346 5.44244 2.36031 5.3393C2.25717 5.23615 2.19922 5.09626 2.19922 4.95039C2.19922 4.80452 2.25717 4.66463 2.36031 4.56148C2.46346 4.45834 2.60335 4.40039 2.74922 4.40039H8.24922ZM6.31432 16.7534C6.37639 17.2895 6.63337 17.7841 7.03638 18.1431C7.43939 18.5021 7.9603 18.7005 8.50002 18.7004H13.4984C14.0381 18.7005 14.559 18.5021 14.9621 18.1431C15.3651 17.7841 15.6221 17.2895 15.6841 16.7534L16.9821 5.50039H5.01632L6.31432 16.7534ZM9.34922 8.25039C9.49509 8.25039 9.63498 8.30834 9.73813 8.41148C9.84127 8.51463 9.89922 8.65452 9.89922 8.80039V15.4004C9.89922 15.5463 9.84127 15.6862 9.73813 15.7893C9.63498 15.8924 9.49509 15.9504 9.34922 15.9504C9.20335 15.9504 9.06345 15.8924 8.96031 15.7893C8.85716 15.6862 8.79922 15.5463 8.79922 15.4004V8.80039C8.79922 8.65452 8.85716 8.51463 8.96031 8.41148C9.06345 8.30834 9.20335 8.25039 9.34922 8.25039ZM13.1992 8.80039C13.1992 8.65452 13.1413 8.51463 13.0381 8.41148C12.935 8.30834 12.7951 8.25039 12.6492 8.25039C12.5033 8.25039 12.3635 8.30834 12.2603 8.41148C12.1572 8.51463 12.0992 8.65452 12.0992 8.80039V15.4004C12.0992 15.5463 12.1572 15.6862 12.2603 15.7893C12.3635 15.8924 12.5033 15.9504 12.6492 15.9504C12.7951 15.9504 12.935 15.8924 13.0381 15.7893C13.1413 15.6862 13.1992 15.5463 13.1992 15.4004V8.80039Z" fill="#1D4ED8" />
																				</svg>
																				Remove
																			</button>:""}
																		</div>
																	</li>
																)
															})}
													</ul>
												</div>
											</div>
										</div> :

										<div style={{"paddingBottom":"100px"}}>
											{projectStatus?.code ==="all_languages_approved"?
										    <div className="project-heading">
											<h3>{translate("other_integrations_project_creation.workflow_and_followers")}</h3>
											<span>{translate("other_integrations_project_creation.setup_dates_assigne")}{selectedProjectWorkflow?.name}</span>
											<p>Workflows cannot be edited for completed languages.</p>
											</div>:
											<SelectWorkflow setValidation={(isValid)=>setDisableButton(!isValid)} handleProjectFollower={()=>setTabChange(true)} doNotShowFollowers={true} workflowType={selectedProjectWorkflow?.workflowType?.code} currentPageName={CURRENT_PAGE_NAME}/>}
										</div>
									}
								</div>
							</div>
						</div>
					</section>
				</div>
				<div className="stricy-btn flex flex-center no-rightlist">
					<div className="left flex">
						{projectStatus?.open && !projectStatus?.inCancellation && projectStatus?.code != "REOPENED_FOR_TM_REUPLOAD" &&
							<div>
								<button type="button" className="btn-default" onClick={cancelProject} >Cancel Project</button>
							</div>
						}
					</div>
					<div className="left flex">
						<div>
							<button type="button" onClick={backToProject} className="btn-default">Cancel</button>
						</div>
						<div>
							<button disabled={disableButton} onClick={onSubmit} className="btn saveFocus">Save Changes</button>
						</div>
					</div>
				</div>

				{showModalSelectWorkflow && <div id="modelPopup" className="lightbox-panel" aria-labelledby="pFollowers" aria-modal="true" role="dialog">
					<div className="inner-lightbox-panel popup-inner">
						<div className="modal-header flex popup-header">
							<strong id="pFollowers">Add your project's followers</strong>
							<button type="button" className="close close-btn-id" aria-label="close" onKeyDown={handleKeyCloseflow} onClick={hideModalSelectWorkflow} id="close-btn-id">
								<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
									<path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path>
									<path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path>
								</svg>
							</button>
						</div>
						<div className="lightbox-content popup-content">
							<div className="table-responsive">
								<div className="datatable-block ">
									<DataTable columns={columns} data={projectFollowers} selectableRows onSelectedRowsChange={selectFollower}
										clearSelectedRows={toggleCleared} onSort={customSort} noDataComponent={noDataFoundComponent()}/>
								</div>
							</div>
						</div>
						<div className="modal-footer popup-footer workflow-footer">
							<button type="button" className="btn btn-bold active"  id="followerAdd"
							 onClick={addFollower}>
								Add
							</button>
							<button type="button" className="btn btn-bold close-btn-id" onKeyDown={handleKeyEditflow} onClick={hideModalSelectWorkflow}
							id="cancel-popup-id">Cancel</button>
						</div>
					</div>
				</div>
				}
				{newBidModelStatus && <div id="modelPopup" className="lightbox-panel" aria-labelledby="submitnewBids" aria-modal="true" role="dialog">
					<div className="inner-lightbox-panel pb-0">
						<div className="modal-header flex padd-lr">
							<strong id="submitnewBids">Changes Require Vendors to Submit New Bids</strong>
						</div>
						<div className="lightbox-content padd-22">
							<p>Your changes to the project dates, intended use, or target languages will require vendors to provide new bids. If you do not want to restart bidding, click "Cancel" and exit the project edit screen. Otherwise, click "Accept" and vendors will be notified of your changes.</p>
						</div>
						<div className="modal-footer modal-footer-border flex px-22">
							<button type="button" className="btn btn-bold first-focus" onClick={hideNewBidModal}>Cancel</button>
							<button type="button" id="renameId" onKeyDown={handleKeyDeleteflow} className="btn btn-bold active" onClick={() => updateProject(projectData)}>Accept</button>
						</div>
					</div>
				</div>
				}
			</div>
			{errorMessage !== "" ? <ErrorMessage class="error-message" message={errorMessage}></ErrorMessage> : ""}
			<div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
				<div className="gb-loader">
					<RotatingLines
						strokeColor="#0096FF"
						strokeWidth="5"
						width="196"
						visible={true}
					/>
				</div>
			</div>
		</>
	)
}
